"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.frZones = exports.frSubZoneNameMapping = void 0;
var frZones = exports.frZones = [{
  id: 'AJACCIO',
  name: 'Ajaccio',
  country: 'FR',
  cornerNW: {
    latitude: 41.919229,
    longitude: 8.738635
  },
  cornerSE: {
    latitude: 41.919229,
    longitude: 8.738635
  },
  deliveryFee: 5,
  subZones: [{
    name: '20 - Ajaccio',
    zipcodes: {
      20167: {
        label: 'Baleone'
      },
      20000: {
        label: 'Ajaccio'
      }
    }
  }]
}, {
  id: 'ALENCON',
  name: 'Alençon',
  country: 'FR',
  cornerNW: {
    latitude: 48.433331,
    longitude: 0.08333
  },
  cornerSE: {
    latitude: 48.433331,
    longitude: 0.08333
  },
  subZones: [{
    name: '61 - Alençon',
    zipcodes: {
      61000: {
        label: 'Alençon'
      },
      61250: {
        label: 'Condé sur Sarthe'
      }
    }
  }]
}, {
  id: 'AMIENS',
  name: 'Amiens',
  country: 'FR',
  cornerNW: {
    latitude: 45.955074,
    longitude: 6.028595
  },
  cornerSE: {
    latitude: 45.823163,
    longitude: 6.177769
  },
  deliveryFee: 5,
  subZones: [{
    name: '80 - Amiens',
    zipcodes: {
      80000: {
        label: 'Amiens',
        intervalForFirstSlotInHours: 4
      },
      80080: {
        label: 'Amiens',
        intervalForFirstSlotInHours: 4
      },
      80090: {
        label: 'Amiens',
        intervalForFirstSlotInHours: 4
      }
    }
  }, {
    name: '80 - Amiens - Est',
    zipcodes: {
      80440: {
        label: 'Glisy'
      }
    }
  }]
}, {
  id: 'ANGERS',
  name: 'Angers',
  country: 'FR',
  cornerNW: {
    latitude: 47.478419,
    longitude: -0.563166
  },
  cornerSE: {
    latitude: 47.478419,
    longitude: -0.563166
  },
  deliveryFee: 5,
  subZones: [{
    name: '49 - Angers',
    zipcodes: {
      49000: {
        label: 'Angers'
      },
      49100: {
        label: 'Angers'
      },
      49200: {
        label: '49200'
      },
      49220: {
        label: '49220'
      },
      49300: {
        label: 'Cholet'
      },
      49400: {
        label: 'Saumur'
      },
      49770: {
        label: '49770'
      }
    }
  }]
}, {
  id: 'ANGOULEME',
  name: 'Angoulême',
  country: 'FR',
  cornerNW: {
    latitude: 45.648377,
    longitude: 0.156236
  },
  cornerSE: {
    latitude: 45.648377,
    longitude: 0.156236
  },
  deliveryFee: 5,
  subZones: [{
    name: '16 - Angoulême',
    zipcodes: {
      16000: {
        label: 'Angoulême'
      },
      16430: {
        label: '16430'
      },
      16006: {
        label: '16006'
      }
    }
  }]
}, {
  id: 'ANNECY',
  name: 'Annecy',
  country: 'FR',
  cornerNW: {
    latitude: 45.955074,
    longitude: 6.028595
  },
  cornerSE: {
    latitude: 45.823163,
    longitude: 6.177769
  },
  deliveryFee: 5,
  subZones: [{
    name: '74 - Annecy',
    zipcodes: {
      74000: {
        label: 'Annecy',
        intervalForFirstSlotInHours: 4
      },
      74160: {
        label: 'Saint-Julien-en-Genevois'
      },
      74290: {
        label: 'Veyrier-du-Lac Menthon-Saint-Ber'
      },
      74300: {
        label: 'Cluses'
      },
      74330: {
        label: 'Poisy'
      },
      74370: {
        label: 'Pringy Villaz Metz-Tessy Argonay'
      },
      74410: {
        label: 'Saint-Jorioz Duingt Saint-Eustache'
      },
      74540: {
        label: 'Alby-sur-Chéran Saint-Félix Cusy'
      },
      74600: {
        label: 'Seynod QUintal Montagny-les-Lanc'
      },
      74650: {
        label: 'Chavanod'
      },
      74940: {
        label: 'Annecy-le-vieux'
      },
      74960: {
        label: 'Cran-Gevrier Meythet'
      }
    }
  }]
}, {
  id: 'AUXERRE',
  name: 'Auxerre',
  country: 'FR',
  cornerNW: {
    latitude: 47.7961287,
    longitude: 3.570579
  },
  cornerSE: {
    latitude: 47.7961287,
    longitude: 3.570579
  },
  deliveryFee: 5,
  subZones: [{
    name: '89 - Auxerre',
    zipcodes: {
      89000: {
        label: 'Auxerre'
      },
      89100: {
        label: 'Sens'
      },
      89140: {
        label: 'Pont-sur-Yonne'
      },
      89200: {
        label: 'Avallon'
      },
      89400: {
        label: 'Migennes'
      }
    }
  }]
}, {
  id: 'BAYONNE',
  name: 'Bayonne',
  country: 'FR',
  cornerNW: {
    latitude: 43.492949,
    longitude: -1.474841
  },
  cornerSE: {
    latitude: 43.492949,
    longitude: -1.474841
  },
  deliveryFee: 5,
  subZones: [{
    name: '64 - Bayonne',
    zipcodes: {
      64100: {
        label: 'Bayonne'
      },
      64200: {
        label: 'Biarritz'
      },
      64300: {
        label: '64300'
      },
      64310: {
        label: 'Ascain Saint-Pée-sur-Nivelle'
      },
      64320: {
        label: 'Bizanos'
      },
      64480: {
        label: '64480'
      },
      64500: {
        label: 'Saint-Jean-de-Luz'
      },
      64600: {
        label: 'Anglet'
      }
    }
  }]
}, {
  id: 'BELLE_ILE_EN_MER',
  name: 'Belle-Île-en-Mer',
  country: 'FR',
  cornerNW: {
    latitude: 47.333332,
    longitude: -3.1833326
  },
  cornerSE: {
    latitude: 47.333332,
    longitude: -3.1833326
  },
  subZones: [{
    name: '56 - Belle-Île-en-Mer',
    zipcodes: {
      56360: {
        label: 'Belle-Île-en-Mer'
      }
    }
  }]
}, {
  id: 'BESANCON',
  name: 'Besançon',
  country: 'FR',
  cornerNW: {
    latitude: 47.241268,
    longitude: 6.025530
  },
  cornerSE: {
    latitude: 47.241268,
    longitude: 6.025530
  },
  deliveryFee: 5,
  subZones: [{
    name: '25 - Besançon',
    zipcodes: {
      25000: {
        label: 'Besançon'
      },
      25110: {
        label: 'Baume-les-Dames'
      },
      25200: {
        label: 'Montbéliard'
      },
      25300: {
        label: 'Pontarlier'
      },
      25400: {
        label: 'Audincourt'
      },
      25480: {
        label: '25480'
      },
      25500: {
        label: 'Morteau'
      },
      25700: {
        label: 'Valentigney'
      }
    }
  }]
}, {
  id: 'BLOIS',
  name: 'Blois',
  country: 'FR',
  cornerNW: {
    latitude: 47.583328,
    longitude: 1.33333
  },
  cornerSE: {
    latitude: 47.583328,
    longitude: 1.33333
  },
  subZones: [{
    name: '41 - Blois',
    zipcodes: {
      41000: {
        label: 'Blois'
      },
      41350: {
        label: 'Vineuil'
      }
    }
  }]
}, {
  id: 'BORDEAUX',
  name: 'Bordeaux',
  country: 'FR',
  cornerNW: {
    latitude: 44.919193,
    longitude: -0.687469
  },
  cornerSE: {
    latitude: 44.795899,
    longitude: -0.512567
  },
  deliveryFee: 5,
  subZones: [{
    name: '33 - Bordeaux',
    zipcodes: {
      33000: {
        label: 'Bordeaux',
        intervalForFirstSlotInHours: 4
      },
      33100: {
        label: 'Bordeaux'
      },
      33800: {
        label: 'Bordeaux'
      }
    }
  }, {
    name: '33 - Bordeaux Nord-Est',
    zipcodes: {
      33310: {
        label: 'Lormont'
      },
      33150: {
        label: 'Cenon'
      },
      33530: {
        label: 'Bassens'
      },
      33560: {
        label: 'Carbon-Blanc Sainte-Eulalie'
      }
    }
  }, {
    name: '33 - Bordeaux Nord-Ouest',
    zipcodes: {
      33110: {
        label: 'Le Bouscat'
      },
      33160: {
        label: 'Saint-Médard-en-Jalles'
      },
      33200: {
        label: 'Caudéran'
      },
      33290: {
        label: 'Blanquefort'
      },
      33300: {
        label: 'Bordeaux-Lac'
      },
      33320: {
        label: 'Eysines'
      },
      33520: {
        label: 'Bruges'
      }
    }
  }, {
    name: '33 - Bordeaux Sud-Est',
    zipcodes: {
      33270: {
        label: 'Floirac Bouliac'
      }
    }
  }, {
    name: '33 - Bordeaux Sud-Ouest',
    zipcodes: {
      33039: {
        label: 'Bègles'
      },
      33130: {
        label: 'Bègles'
      },
      33170: {
        label: 'Gradignan'
      },
      33400: {
        label: 'Talence'
      },
      33600: {
        label: 'Pessac'
      },
      33700: {
        label: 'Merignac'
      }
    }
  }]
}, {
  id: 'BOURG_EN_BRESSE',
  name: 'Bourg-en-Bresse',
  country: 'FR',
  cornerNW: {
    latitude: 46.2051675,
    longitude: 5.2255007
  },
  cornerSE: {
    latitude: 46.2051675,
    longitude: 5.2255007
  },
  subZones: [{
    name: '01 - Bourg-en-Bresse',
    zipcodes: {
      '01000': {
        label: 'Bourg-en-Bresse'
      }
    }
  }]
}, {
  id: 'BOURGE',
  name: 'Bourge',
  country: 'FR',
  cornerNW: {
    latitude: 47.081012,
    longitude: 2.398782
  },
  cornerSE: {
    latitude: 47.081012,
    longitude: 2.398782
  },
  deliveryFee: 5,
  subZones: [{
    name: '18 - Bourges',
    zipcodes: {
      18000: {
        label: 'Bourges'
      }
    }
  }]
}, {
  id: 'BREST',
  name: 'Brest',
  country: 'FR',
  cornerNW: {
    latitude: 48.390394,
    longitude: -4.486076
  },
  cornerSE: {
    latitude: 48.390394,
    longitude: -4.486076
  },
  deliveryFee: 5,
  subZones: [{
    name: '29 - Brest',
    zipcodes: {
      29200: {
        label: 'Brest'
      }
    }
  }, {
    name: '29 - Crozon',
    zipcodes: {
      29160: {
        label: 'Crozon'
      }
    }
  }, {
    name: '29 - Morlaix',
    zipcodes: {
      29600: {
        label: 'Morlaix'
      },
      29250: {
        label: 'Saint-Pol-de-Léon'
      }
    }
  }]
}, {
  id: 'BRIVE',
  name: 'Brive-la-Gaillarde',
  country: 'FR',
  cornerNW: {
    latitude: 45.1584982,
    longitude: 1.5332389
  },
  cornerSE: {
    latitude: 45.1584982,
    longitude: 1.53323890
  },
  deliveryFee: 5,
  subZones: [{
    name: '19 - Brive-la-Gaillarde',
    zipcodes: {
      19100: {
        label: 'Brive-la-Gaillarde'
      },
      19200: {
        label: 'Ussel'
      },
      19300: {
        label: 'Égletons'
      },
      19400: {
        label: 'Argentat'
      },
      19500: {
        label: 'Collonges-la-Rouge'
      },
      19600: {
        label: '19600'
      }
    }
  }]
}, {
  id: 'CAEN',
  name: 'Caen',
  country: 'FR',
  cornerNW: {
    latitude: 49.216758,
    longitude: -0.419466
  },
  cornerSE: {
    latitude: 49.152704,
    longitude: -0.329293
  },
  deliveryFee: 5,
  subZones: [{
    name: '14 - Caen',
    zipcodes: {
      14000: {
        label: 'Caen',
        intervalForFirstSlotInHours: 4
      },
      14111: {
        label: 'Louvigny'
      },
      14112: {
        label: 'Biéville-Beuville Périers-sur-Le'
      },
      14120: {
        label: 'Mondeville'
      },
      14123: {
        label: 'Ifs Cormelles-le-Royal Fleury-su'
      },
      14200: {
        label: 'Hérouville-Saint-Clair'
      },
      14280: {
        label: 'Saint-Germain-La-Blanche-Herbe'
      },
      14300: {
        label: '14300'
      },
      14460: {
        label: 'Colombelles'
      },
      14540: {
        label: 'Soliers Bourguébus Grentheville'
      },
      14550: {
        label: 'Blainville-sur-Orne'
      },
      14630: {
        label: 'Cagny Frénouville Émiéville'
      },
      14650: {
        label: 'Carpiquet'
      },
      14670: {
        label: 'St Pair'
      },
      14730: {
        label: 'Giberville'
      },
      14760: {
        label: 'Bretteville-sur-Odon'
      },
      14790: {
        label: 'Verson Fontaine-Étoupefour Mouen'
      },
      14810: {
        label: '14810'
      },
      14840: {
        label: 'Démouville Cuverville'
      },
      14850: {
        label: 'Hérouvillette Escoville'
      },
      14920: {
        label: 'Mathieu'
      },
      14930: {
        label: 'Éterville Maltot Vieux'
      },
      14970: {
        label: "Bénouville Saint-Aubin-d'Arquena"
      },
      14980: {
        label: 'Rots'
      }
    }
  }, {
    name: '14 - Deauville / Trouville',
    zipcodes: {
      14360: {
        label: 'Trouville-sur-Mer'
      },
      14800: {
        label: 'Deauville'
      },
      14910: {
        label: 'Benerville-sur-Mer'
      }
    }
  }]
}, {
  id: 'CALAIS',
  name: 'Calais',
  country: 'FR',
  cornerNW: {
    latitude: 50.95129,
    longitude: 1.858686
  },
  cornerSE: {
    latitude: 50.95129,
    longitude: 1.858686
  },
  deliveryFee: 5,
  subZones: [{
    name: '62 - Calais',
    zipcodes: {
      62901: {
        label: 'Calais'
      },
      62100: {
        label: 'Calais'
      }
    }
  }]
}, {
  id: 'CANNES',
  name: 'Cannes',
  country: 'FR',
  cornerNW: {
    latitude: 43.57468,
    longitude: 6.937943
  },
  cornerSE: {
    latitude: 43.528572,
    longitude: 7.059791
  },
  deliveryFee: 5,
  subZones: [{
    name: '06 - Cannes et alentours',
    zipcodes: {
      '06110': {
        label: 'Cannet'
      },
      '06150': {
        label: 'La Bocca'
      },
      '06160': {
        label: 'Juan-les-pins'
      },
      '06210': {
        label: 'Mandelieu-la-Napoule La Napoule'
      },
      '06220': {
        label: 'Vallauris'
      },
      '06250': {
        label: 'Mougins'
      },
      '06370': {
        label: 'Mouans-Sartoux'
      },
      '06400': {
        label: 'Cannes'
      },
      '06550': {
        label: 'Roquette-sur-Siagne'
      },
      '06560': {
        label: 'Valbonne'
      },
      '06580': {
        label: 'Pégomas'
      },
      '06590': {
        label: 'Théoule-sur-Mer'
      },
      '06600': {
        label: 'Antibes'
      },
      '06810': {
        label: 'Auribeau-sur-Siagne'
      }
    }
  }, {
    name: '83 - Fréjus',
    zipcodes: {
      83370: {
        label: 'Fréjus'
      },
      83371: {
        label: 'Fréjus'
      },
      83372: {
        label: 'Fréjus'
      },
      83379: {
        label: 'Fréjus'
      },
      83600: {
        label: 'Fréjus'
      },
      83601: {
        label: 'Fréjus'
      },
      83602: {
        label: 'Fréjus'
      },
      83603: {
        label: 'Fréjus'
      },
      83604: {
        label: 'Fréjus'
      },
      83606: {
        label: 'Fréjus'
      },
      83608: {
        label: 'Fréjus'
      },
      83609: {
        label: 'Fréjus'
      },
      83613: {
        label: 'Fréjus'
      },
      83614: {
        label: 'Fréjus'
      },
      83615: {
        label: 'Fréjus'
      },
      83616: {
        label: 'Fréjus'
      },
      83618: {
        label: 'Fréjus'
      }
    }
  }]
}, {
  id: 'CHALON_SUR_SAONE',
  name: 'Chalon-sur-Saône',
  country: 'FR',
  cornerNW: {
    latitude: 46.7810442,
    longitude: 4.8541306
  },
  cornerSE: {
    latitude: 46.7810442,
    longitude: 4.8541306
  },
  subZones: [{
    name: '71 - Mâcon',
    zipcodes: {
      71400: {
        label: 'Autun'
      }
    }
  }]
}, {
  id: 'CHAMBERY',
  name: 'Chambéry',
  country: 'FR',
  cornerNW: {
    latitude: 45.5662672,
    longitude: 5.9203636
  },
  cornerSE: {
    latitude: 45.5662672,
    longitude: 5.9203636
  },
  deliveryFee: 5,
  subZones: [{
    name: '73 - Chambéry',
    zipcodes: {
      73000: {
        label: 'Chambéry'
      },
      73100: {
        label: 'Aix-les-Bains'
      },
      73200: {
        label: 'Albertville'
      },
      73300: {
        label: 'Saint-Jean-de-Maurienne'
      },
      73400: {
        label: 'Ugine'
      },
      73500: {
        label: '73500'
      },
      73800: {
        label: 'Montmélian'
      }
    }
  }]
}, {
  id: 'CHARLEVILLE_MEZIERES',
  name: 'Charleville-Mézières',
  country: 'FR',
  cornerNW: {
    latitude: 49.773739,
    longitude: 4.719920
  },
  cornerSE: {
    latitude: 49.773739,
    longitude: 4.719920
  },
  deliveryFee: 5,
  subZones: [{
    name: '08 - Charleville-Mézières',
    zipcodes: {
      '08000': {
        label: 'Charleville-Mézières'
      },
      '08160': {
        label: 'Champion'
      },
      '08170': {
        label: '08170'
      },
      '08400': {
        label: 'Vouziers'
      }
    }
  }]
}, {
  id: 'CHATEAUROUX',
  name: 'Châteauroux',
  country: 'FR',
  cornerNW: {
    latitude: 46.8114340,
    longitude: 1.6867790
  },
  cornerSE: {
    latitude: 46.8114340,
    longitude: 1.6867790
  },
  subZones: [{
    name: '36 - Châteauroux',
    zipcodes: {
      36000: {
        label: 'Châteauroux'
      }
    }
  }]
}, {
  id: 'CHAUMONT',
  name: 'Chaumont',
  country: 'FR',
  cornerNW: {
    latitude: 48.1111324,
    longitude: 5.1395849
  },
  cornerSE: {
    latitude: 48.1111324,
    longitude: 5.1395849
  },
  deliveryFee: 5,
  subZones: [{
    name: '52 - Chaumont',
    zipcodes: {
      52000: {
        label: 'Chaumont'
      },
      52100: {
        label: 'Saint-Dizier'
      },
      52200: {
        label: 'Langres'
      },
      52300: {
        label: '52300'
      },
      52340: {
        label: '52340'
      }
    }
  }]
}, {
  id: 'CHERBOURG',
  name: 'Cherbourg',
  country: 'FR',
  cornerNW: {
    latitude: 49.638672,
    longitude: 1.614240
  },
  cornerSE: {
    latitude: 49.638672,
    longitude: 1.614240
  },
  deliveryFee: 5,
  subZones: [{
    name: '50 - Cherbourg',
    zipcodes: {
      50100: {
        label: 'Cherbourg-en-Cotentin'
      },
      50200: {
        label: 'Coutances'
      },
      50400: {
        label: 'Granville'
      },
      50470: {
        label: 'Cherbourg'
      },
      50500: {
        label: 'Carentan'
      },
      50600: {
        label: 'Saint-Hilaire-du-Harcouët'
      },
      50700: {
        label: 'Valognes'
      },
      50800: {
        label: '50800'
      },
      50900: {
        label: '50900'
      }
    }
  }]
}, {
  id: 'CLERMONT_FERRAND',
  name: 'Clermont-Ferrand',
  country: 'FR',
  cornerNW: {
    latitude: 45.777222,
    longitude: 3.087025
  },
  cornerSE: {
    latitude: 45.777222,
    longitude: 3.087025
  },
  deliveryFee: 5,
  subZones: [{
    name: '63 - Clermont-Ferrand',
    zipcodes: {
      63000: {
        label: 'Clermont-Ferrand'
      },
      63100: {
        label: 'Clermont-Ferrand'
      },
      63200: {
        label: 'Riom'
      },
      63300: {
        label: 'Thiers'
      },
      63400: {
        label: 'Chamalieres'
      }
    }
  }]
}, {
  id: 'DIEPPE',
  name: 'Dieppe',
  country: 'FR',
  cornerNW: {
    latitude: 49.933331,
    longitude: 1.08333
  },
  cornerSE: {
    latitude: 49.933331,
    longitude: 1.08333
  },
  subZones: [{
    name: '76 - Dieppe',
    zipcodes: {
      76200: {
        label: 'Dieppe'
      }
    }
  }]
}, {
  id: 'DIGNE',
  name: 'Digne-les-Bains',
  country: 'FR',
  cornerNW: {
    latitude: 44.0918144,
    longitude: 6.2351431
  },
  cornerSE: {
    latitude: 44.0918144,
    longitude: 6.2351431
  },
  deliveryFee: 5,
  subZones: [{
    name: '04 - Digne-les-Bains',
    zipcodes: {
      '04000': {
        label: 'Digne-les-Bains'
      },
      '04100': {
        label: 'Manosque'
      },
      '04200': {
        label: 'Sisteron'
      },
      '04300': {
        label: 'Forcalquier'
      },
      '04400': {
        label: 'Barcelonnette'
      },
      '04500': {
        label: '04500'
      }
    }
  }]
}, {
  id: 'DIJON',
  name: 'Dijon',
  country: 'FR',
  cornerNW: {
    latitude: 47.322047,
    longitude: 5.04148
  },
  cornerSE: {
    latitude: 47.322047,
    longitude: 5.04148
  },
  deliveryFee: 5,
  subZones: [{
    name: '21 - Dijon',
    zipcodes: {
      21000: {
        label: 'Dijon'
      },
      21100: {
        label: 'Brain'
      },
      21110: {
        label: 'Genlis'
      },
      21120: {
        label: 'Is-sur-Tille'
      },
      21160: {
        label: 'Marsannay-la-Côte'
      },
      21240: {
        label: 'Talant'
      },
      21300: {
        label: 'Chenôve'
      },
      21550: {
        label: '21550'
      }
    }
  }]
}, {
  id: 'DREUX',
  name: 'Dreux',
  country: 'FR',
  cornerNW: {
    latitude: 48.7348418,
    longitude: 1.3685054
  },
  cornerSE: {
    latitude: 48.7348418,
    longitude: 1.3685054
  },
  subZones: [{
    name: '28 - Dreux',
    zipcodes: {
      28100: {
        label: 'Dreux'
      },
      28500: {
        label: 'Vernouillet'
      }
    }
  }]
}, {
  id: 'DUNKERQUE',
  name: 'Dunkerque',
  country: 'FR',
  cornerNW: {
    latitude: 51.034368,
    longitude: 2.376776
  },
  cornerSE: {
    latitude: 51.034368,
    longitude: 2.376776
  },
  deliveryFee: 5,
  subZones: [{
    name: '59 - Dunkerque',
    zipcodes: {
      59140: {
        label: 'Dunkerque'
      },
      59640: {
        label: 'Dunkerque'
      },
      59430: {
        label: 'Dunkerque'
      },
      59279: {
        label: 'Dunkerque'
      },
      59240: {
        label: 'Dunkerque'
      }
    }
  }]
}, {
  id: 'EVREUX',
  name: 'Évreux',
  country: 'FR',
  cornerNW: {
    latitude: 49.0270129,
    longitude: 1.1513610
  },
  cornerSE: {
    latitude: 49.0270129,
    longitude: 1.1513610
  },
  subZones: [{
    name: '27 - Évreux',
    zipcodes: {
      27000: {
        label: 'Évreux'
      },
      27930: {
        label: 'Bacquepuis'
      }
    }
  }]
}, {
  id: 'GRANVILLE',
  name: 'Granville',
  country: 'FR',
  cornerNW: {
    latitude: 48.8375790,
    longitude: -1.5973020
  },
  cornerSE: {
    latitude: 48.8375790,
    longitude: -1.5973020
  },
  subZones: [{
    name: '50 - Granville',
    zipcodes: {
      50400: {
        label: 'Granville'
      }
    }
  }]
}, {
  id: 'GRENOBLE',
  name: 'Grenoble',
  country: 'FR',
  cornerNW: {
    latitude: 45.215443,
    longitude: 5.676049
  },
  cornerSE: {
    latitude: 45.154207,
    longitude: 5.753822
  },
  deliveryFee: 5,
  subZones: [{
    name: '38 - Grenoble',
    zipcodes: {
      38000: {
        label: 'Grenoble',
        intervalForFirstSlotInHours: 4
      },
      38045: {
        label: 'Grenoble',
        intervalForFirstSlotInHours: 4
      },
      38100: {
        label: 'Grenoble',
        intervalForFirstSlotInHours: 4
      },
      38120: {
        label: 'Saint-Égrève Fontanil-Cornillon'
      },
      38130: {
        label: 'Échirolles'
      },
      38170: {
        label: 'Seyssinet-Pariset'
      },
      38180: {
        label: 'Seyssins'
      },
      38240: {
        label: 'Meylan'
      },
      38320: {
        label: 'Eybens Brié-et-Angonnes Poisat Bresson Herbeys'
      },
      38360: {
        label: 'Sassenage Noyarey Engins'
      },
      38400: {
        label: "Saint-Marin-d'Hères"
      },
      38600: {
        label: 'Fontaine'
      },
      38610: {
        label: 'Gières Venon'
      },
      38640: {
        label: 'Claix'
      },
      38700: {
        label: 'La Tronche Corenc Le Sappey-en-Chartreuse Sarcenas'
      },
      38800: {
        label: 'Le Pont-de-Claix Champagnier'
      },
      38950: {
        label: 'Saint-Martin-le-Vinoux Quaix-en-Chartreuse'
      }
    }
  }]
}, {
  id: 'LA_ROCHE_SUR_YON',
  name: 'La Roche-sur-Yon',
  country: 'FR',
  cornerNW: {
    latitude: 46.6714317,
    longitude: -1.4180749
  },
  cornerSE: {
    latitude: 46.6714317,
    longitude: -1.4180749
  },
  subZones: [{
    name: '85 - Les Sables-d’Olonne',
    zipcodes: {
      85100: {
        label: 'La Roche-sur-Yon'
      }
    }
  }]
}, {
  id: 'LA_ROCHELLE',
  name: 'La Rochelle',
  country: 'FR',
  cornerNW: {
    latitude: 46.160329,
    longitude: -1.151139
  },
  cornerSE: {
    latitude: 46.160329,
    longitude: -1.151139
  },
  deliveryFee: 5,
  subZones: [{
    name: '17 - La Rochelle',
    zipcodes: {
      17000: {
        label: 'La Rochelle'
      }
    }
  }, {
    name: 'Royan',
    zipcodes: {
      17200: {
        label: 'Royan'
      }
    }
  }]
}, {
  id: 'LAVAL',
  name: 'Laval',
  country: 'FR',
  cornerNW: {
    latitude: 48.0783712,
    longitude: -0.7670206
  },
  cornerSE: {
    latitude: 48.0783712,
    longitude: -0.7670206
  },
  subZones: [{
    name: '53 - Laval',
    zipcodes: {
      53000: {
        label: 'Laval'
      }
    }
  }]
}, {
  id: 'LE_HAVRE',
  name: 'Le Havre',
  country: 'FR',
  cornerNW: {
    latitude: 49.49437,
    longitude: 0.107929
  },
  cornerSE: {
    latitude: 49.49437,
    longitude: 0.107929
  },
  deliveryFee: 5,
  subZones: [{
    name: '76 - Le Havre',
    zipcodes: {
      76600: {
        label: 'Le Havre'
      },
      76620: {
        label: 'Le Havre'
      },
      76610: {
        label: 'Le Havre'
      },
      76310: {
        label: 'Le Havre'
      }
    }
  }]
}, {
  id: 'LE_MANS',
  name: 'Le Mans',
  country: 'FR',
  cornerNW: {
    latitude: 48.00611,
    longitude: 0.199556
  },
  cornerSE: {
    latitude: 48.00611,
    longitude: 0.199556
  },
  deliveryFee: 5,
  subZones: [{
    name: '72 - Le Mans',
    zipcodes: {
      72000: {
        label: 'Le Mans'
      },
      72100: {
        label: 'Le Mans'
      },
      72230: {
        label: 'Arnage'
      },
      72240: {
        label: '72240'
      },
      72250: {
        label: 'Parigné-l’Évêque'
      },
      72300: {
        label: 'Sablé-sur-Sarthe'
      },
      72380: {
        label: 'Montbizot Souillé'
      },
      72560: {
        label: 'Change Saint-Saturnin'
      },
      72610: {
        label: '72610'
      }
    }
  }]
}, {
  id: 'LE_TOUQUET',
  name: 'Le Touquet',
  country: 'FR',
  cornerNW: {
    latitude: 50.5212760,
    longitude: 1.5906750
  },
  cornerSE: {
    latitude: 50.5212760,
    longitude: 1.5906750
  },
  subZones: [{
    name: '62 - Le Touquet',
    zipcodes: {
      62520: {
        label: 'Le Touquet'
      }
    }
  }]
}, {
  id: 'LILLE',
  name: 'Lille',
  country: 'FR',
  cornerNW: {
    latitude: 50.662504,
    longitude: 2.963731
  },
  cornerSE: {
    latitude: 50.601763,
    longitude: 3.130073
  },
  deliveryFee: 5,
  subZones: [{
    name: '59 - Lille Loos / Haubourdin',
    zipcodes: {
      59000: {
        label: 'Lille',
        intervalForFirstSlotInHours: 4
      },
      59120: {
        label: 'Loos'
      },
      59139: {
        label: 'Noyelles-lès-Seclin'
      },
      59211: {
        label: 'Santes'
      },
      59263: {
        label: 'Houplin-Ancoisne'
      },
      59273: {
        label: 'Houplin-Ancoisne'
      },
      59320: {
        label: 'Haubourdin Hallennes-lez-Haubour'
      }
    }
  }, {
    name: '59 - Lille Nord Est',
    zipcodes: {
      59110: {
        label: 'La Madeleine'
      },
      59118: {
        label: 'Wambrechies'
      },
      59170: {
        label: 'Croix'
      },
      59200: {
        label: 'Tourcoing'
      },
      59290: {
        label: 'Wasquehal'
      },
      59420: {
        label: 'Mouvaux'
      },
      59520: {
        label: 'Marquette-lez-Lille'
      },
      59700: {
        label: 'Marcq-en-Barœul'
      },
      59777: {
        label: 'Lille',
        intervalForFirstSlotInHours: 4
      },
      59800: {
        label: 'Lille',
        intervalForFirstSlotInHours: 4
      },
      59910: {
        label: 'Bondues'
      }
    }
  }, {
    name: '59 - Lille Seclin',
    zipcodes: {
      59113: {
        label: 'Seclin'
      }
    }
  }, {
    name: '59 - Lille Nord Ouest',
    zipcodes: {
      59130: {
        label: 'Lambersart'
      },
      59160: {
        label: 'Lille Lomme'
      },
      59237: {
        label: 'Verlinghem'
      },
      59350: {
        label: 'Lille'
      },
      59390: {
        label: '59390'
      },
      59840: {
        label: 'Pérenchies Lompret Prémesques'
      }
    }
  }, {
    name: '59 - Lille Sud',
    zipcodes: {
      59155: {
        label: 'Fâches-Thumesnil'
      },
      59175: {
        label: 'Templemars Vendeville'
      },
      59790: {
        label: 'Ronchin'
      },
      62950: {
        label: 'Noyelle Godault'
      }
    }
  }, {
    name: '59 - Lille',
    zipcodes: {
      59260: {
        label: 'Quartier des Hellemmes',
        intervalForFirstSlotInHours: 4
      },
      59262: {
        label: 'Sainghin-en-Mélantois'
      },
      59370: {
        label: 'Mons-en-Baroeul'
      },
      59491: {
        label: "Villeneuve-d'Ascq (2)"
      },
      59493: {
        label: "Villeneuve-d'Ascq (2)"
      },
      59510: {
        label: 'Hem Forest-sur-Marque'
      },
      59650: {
        label: "Villeneuve-d'Ascq (1)"
      },
      59810: {
        label: 'Lesquin'
      }
    }
  }]
}, {
  id: 'LIMOGES',
  name: 'Limoges',
  country: 'FR',
  cornerNW: {
    latitude: 45.833619,
    longitude: 1.261105
  },
  cornerSE: {
    latitude: 45.833619,
    longitude: 1.261105
  },
  deliveryFee: 5,
  subZones: [{
    name: '87 - Limoges',
    zipcodes: {
      87000: {
        label: 'Limoges'
      },
      87100: {
        label: 'Limoges'
      },
      87220: {
        label: 'Feuillardiers'
      },
      87350: {
        label: 'Panazol'
      },
      87410: {
        label: 'Condat-sur-Vienne'
      },
      87570: {
        label: '87570'
      }
    }
  }]
}, {
  id: 'LORIENT',
  name: 'Lorient',
  country: 'FR',
  cornerNW: {
    latitude: 47.748,
    longitude: -3.366
  },
  cornerSE: {
    latitude: 47.748,
    longitude: -3.366
  },
  deliveryFee: 5,
  subZones: [{
    name: '56 - Lorient',
    zipcodes: {
      56000: {
        label: 'Vannes'
      },
      56100: {
        label: 'Lorient'
      },
      56400: {
        label: 'Auray'
      },
      56600: {
        label: 'Lanester'
      }
    }
  }, {
    name: '56 - Pontivy',
    zipcodes: {
      56300: {
        label: 'Pontivy'
      }
    }
  }]
}, {
  id: 'LYON',
  name: 'Lyon',
  country: 'FR',
  cornerNW: {
    latitude: 45.803251,
    longitude: 4.776678
  },
  cornerSE: {
    latitude: 45.698921,
    longitude: 4.902279
  },
  deliveryFee: 5,
  subZones: [{
    name: '69 - Lyon',
    zipcodes: {
      69001: {
        label: 'Lyon 1er arrondissement',
        intervalForFirstSlotInHours: 4
      },
      69002: {
        label: 'Lyon 2eme arrondissement',
        intervalForFirstSlotInHours: 4
      },
      69003: {
        label: 'Lyon 3eme arrondissement',
        intervalForFirstSlotInHours: 4
      },
      69004: {
        label: 'Lyon 4eme arrondissement',
        intervalForFirstSlotInHours: 4
      },
      69005: {
        label: 'Lyon 5eme arrondissement',
        intervalForFirstSlotInHours: 4
      },
      69006: {
        label: 'Lyon 6eme arrondissement',
        intervalForFirstSlotInHours: 4
      },
      69007: {
        label: 'Lyon 7eme arrondissement',
        intervalForFirstSlotInHours: 4
      },
      69008: {
        label: 'Lyon 8eme arrondissement',
        intervalForFirstSlotInHours: 4
      },
      69009: {
        label: 'Lyon 9eme arrondissement',
        intervalForFirstSlotInHours: 4
      }
    }
  }, {
    name: '69 - Lyon Villeurbanne',
    zipcodes: {
      69100: {
        label: 'Villeurbane',
        deliveryFee: 15
      }
    }
  }, {
    name: '69 - Lyon Alentours',
    zipcodes: {
      69110: {
        label: 'St Foy les Lyon',
        deliveryFee: 15
      },
      69120: {
        label: 'Vaulx-en-Velin',
        deliveryFee: 15
      },
      69130: {
        label: 'Ecully'
      },
      69160: {
        label: 'Tassin-la-Demi-Lune'
      },
      69190: {
        label: 'Saint-Fons',
        deliveryFee: 15
      },
      69200: {
        label: 'Vénissieux',
        deliveryFee: 15
      },
      69230: {
        label: 'Saint-Genis Laval',
        deliveryFee: 15
      },
      69260: {
        label: 'Charbonnières les Bains',
        deliveryFee: 15
      },
      69290: {
        label: 'Craponne Grézieu la Varenne Poll',
        deliveryFee: 15
      },
      69300: {
        label: 'Caluire',
        deliveryFee: 15
      },
      69310: {
        label: 'Pierre Bénite',
        deliveryFee: 15
      },
      69320: {
        label: 'Feyzin',
        deliveryFee: 15
      },
      69340: {
        label: 'Francheville',
        deliveryFee: 15
      },
      69350: {
        label: 'La Mulatière',
        deliveryFee: 15
      },
      69360: {
        label: 'Saint-Symphorien d’Ozon'
      },
      69370: {
        label: "Saint-Didier-au-Mont-d'Or",
        deliveryFee: 15
      },
      69410: {
        label: "Champagne au Mont d'Or",
        deliveryFee: 15
      },
      69450: {
        label: "Saint-Cyr au Mont d'Or",
        deliveryFee: 15
      },
      69500: {
        label: 'Bron',
        deliveryFee: 15
      },
      69540: {
        label: 'Irigny',
        deliveryFee: 15
      },
      69570: {
        label: 'Dardilly',
        deliveryFee: 15
      },
      69600: {
        label: 'Oullins',
        deliveryFee: 15
      },
      69630: {
        label: 'Chaponost',
        deliveryFee: 15
      },
      69680: {
        label: 'Chassieu'
      },
      69800: {
        label: 'Saint-Priest',
        deliveryFee: 15
      },
      '01700': {
        label: 'Beynost'
      },
      38090: {
        label: 'Villefontaine'
      },
      38230: {
        label: 'Tignieu-Jameyzieu'
      }
    }
  }, {
    name: '69 - Lyon Rilleux',
    zipcodes: {
      69140: {
        label: 'Rilleux-la-Pape',
        deliveryFee: 15
      }
    }
  }]
}, {
  id: 'MACON',
  name: 'Mâcon',
  country: 'FR',
  cornerNW: {
    latitude: 46.3079587,
    longitude: 4.8293535
  },
  cornerSE: {
    latitude: 46.3079587,
    longitude: 4.8293535
  },
  subZones: [{
    name: '71 - Mâcon',
    zipcodes: {
      71000: {
        label: 'Mâcon'
      },
      71250: {
        label: 'Cluny'
      }
    }
  }]
}, {
  id: 'MARSEILLE_AIX',
  name: 'Marseille / Aix',
  country: 'FR',
  cornerNW: {
    latitude: 43.62037483233502,
    longitude: 5.295963901626578
  },
  cornerSE: {
    latitude: 43.19760956070986,
    longitude: 5.479812310247439
  },
  deliveryFee: 5,
  subZones: [{
    name: '13 - Marseille Hypercentre',
    zipcodes: {
      13001: {
        label: 'Marseille 1er',
        intervalForFirstSlotInHours: 4
      },
      13002: {
        label: 'Marseille 2eme',
        intervalForFirstSlotInHours: 4
      },
      13003: {
        label: 'Marseille 3eme',
        intervalForFirstSlotInHours: 4
      }
    }
  }, {
    name: '13 - Marseille Centre',
    zipcodes: {
      13004: {
        label: 'Marseille 4eme',
        intervalForFirstSlotInHours: 4
      },
      13005: {
        label: 'Marseille 5eme',
        intervalForFirstSlotInHours: 4
      },
      13006: {
        label: 'Marseille 6eme',
        intervalForFirstSlotInHours: 4
      }
    }
  }, {
    name: '13 - Marseille 7',
    zipcodes: {
      13007: {
        label: 'Marseille 7eme',
        intervalForFirstSlotInHours: 4
      }
    }
  }, {
    name: '13 - Marseille Sud',
    zipcodes: {
      13008: {
        label: 'Marseille 8eme',
        deliveryFee: 15,
        intervalForFirstSlotInHours: 4
      },
      13009: {
        label: 'Marseille 9eme',
        deliveryFee: 15,
        intervalForFirstSlotInHours: 4
      },
      13010: {
        label: 'Marseille 10eme',
        deliveryFee: 15,
        intervalForFirstSlotInHours: 4
      },
      13011: {
        label: 'Marseille 11eme',
        deliveryFee: 15,
        intervalForFirstSlotInHours: 4
      },
      13012: {
        label: 'Marseille 12eme',
        deliveryFee: 15,
        intervalForFirstSlotInHours: 4
      }
    }
  }, {
    name: '13 - Marseille Nord',
    zipcodes: {
      13013: {
        label: 'Marseille 13eme',
        intervalForFirstSlotInHours: 4
      },
      13014: {
        label: 'Marseille 14eme',
        intervalForFirstSlotInHours: 4
      },
      13015: {
        label: 'Marseille 15eme',
        intervalForFirstSlotInHours: 4
      },
      13016: {
        label: 'Marseille 16eme',
        intervalForFirstSlotInHours: 4
      }
    }
  }, {
    name: '13 - Aix-en-Provence',
    zipcodes: {
      13380: {
        label: 'Plan de Cuques'
      },
      13290: {
        label: 'Aix les Milles'
      },
      13950: {
        label: 'Allauch'
      }
    }
  }, {
    name: '13 - Aix-en-Provence Sud',
    zipcodes: {
      13080: {
        label: 'Aix Luynes'
      },
      13120: {
        label: 'Gardanne',
        deliveryFee: 15
      },
      13320: {
        label: 'Bouc bel air',
        deliveryFee: 15
      },
      13480: {
        label: 'Cabriès',
        deliveryFee: 15
      },
      13590: {
        label: 'Meyreuil',
        deliveryFee: 15
      }
    }
  }, {
    name: '13 - Aix-en-Provence Nord',
    zipcodes: {
      13090: {
        label: 'Aix'
      },
      13122: {
        label: 'Ventabrun',
        deliveryFee: 15
      },
      13510: {
        label: 'Eguilles',
        deliveryFee: 15
      },
      13540: {
        label: 'Aix Puyricard'
      },
      13770: {
        label: 'Venelles',
        deliveryFee: 15
      }
    }
  }, {
    name: '13 - Aix-en-Provence Est',
    zipcodes: {
      13100: {
        label: 'Aix le Tholonet Saint-Marc-Jaume'
      }
    }
  }, {
    name: '13 - Aubagne-Gémenos',
    zipcodes: {
      13400: {
        label: 'Aubagne'
      },
      13420: {
        label: 'Gémenos'
      },
      13600: {
        label: 'La Ciotat'
      }
    }
  }, {
    name: '13 - Marignane',
    zipcodes: {
      13220: {
        label: 'Châteauneuf-les-Martigues'
      }
    }
  }, {
    name: '13 - Salon-de-Provence',
    zipcodes: {
      13300: {
        label: 'Salon-de-Provence'
      },
      13140: {
        label: 'Miramas'
      }
    }
  }]
}, {
  id: 'METZ',
  name: 'Metz - Nancy',
  country: 'FR',
  cornerNW: {
    latitude: 49.157096,
    longitude: 6.107081
  },
  cornerSE: {
    latitude: 49.059383,
    longitude: 6.275795
  },
  deliveryFee: 10,
  subZones: [{
    name: '54 - Nancy',
    zipcodes: {
      54000: {
        label: 'Nancy',
        intervalForFirstSlotInHours: 4
      },
      54100: {
        label: 'Nancy',
        intervalForFirstSlotInHours: 4
      },
      54110: {
        label: 'Varangéville'
      },
      54130: {
        label: 'Saint-Max'
      },
      54136: {
        label: 'Bouxières-aux-Dames'
      },
      54210: {
        label: 'Saint-Nicolas-de-Port'
      },
      54250: {
        label: 'Champigneulles'
      },
      54270: {
        label: 'Essey-lès-Nancy'
      },
      54320: {
        label: 'Maxéville'
      },
      54390: {
        label: 'Frouard'
      },
      54400: {
        label: 'Longwy'
      },
      54500: {
        label: 'Vandœuvre-lès-Nancy'
      },
      54510: {
        label: 'Tomblaine'
      },
      54520: {
        label: 'Laxou'
      },
      54600: {
        label: 'Villers-lès-Nancy'
      },
      54700: {
        label: 'Pont-à-Mousson'
      },
      57127: {
        label: 'Thionville'
      }
    }
  }, {
    name: '57 - Metz',
    zipcodes: {
      57000: {
        label: 'Metz',
        intervalForFirstSlotInHours: 4
      },
      57050: {
        label: 'Metz Plappeville Vantoux Ban St'
      },
      57070: {
        label: 'Metz St Julien La Grange aux boi'
      },
      57130: {
        label: 'Ancy sur Moselle Ars sur Moselle'
      },
      57140: {
        label: 'Woippy la Maxe'
      },
      57151: {
        label: 'Marly (1)'
      },
      57155: {
        label: 'Marly (2)'
      },
      57158: {
        label: 'Montigny (2)'
      },
      57160: {
        label: 'Scy-Chazelles Moulins'
      },
      57245: {
        label: 'Peltre'
      },
      57280: {
        label: 'Semécourt'
      },
      57535: {
        label: 'Marange-Silvange Bronvaux'
      },
      57645: {
        label: 'Retonfey Montoy-Flanville Noisse'
      },
      57685: {
        label: 'Augny'
      },
      57950: {
        label: 'Montigny'
      }
    }
  }]
}, {
  id: 'MONACO',
  name: 'Monaco',
  country: 'FR',
  cornerNW: {
    latitude: 43.738418,
    longitude: 7.424616
  },
  cornerSE: {
    latitude: 43.738418,
    longitude: 7.424616
  },
  deliveryFee: 5,
  subZones: [{
    name: '98 - Monaco',
    zipcodes: {
      98000: {
        label: 'Monaco'
      }
    }
  }]
}, {
  id: 'MONT_DE_MARSAN',
  name: 'Mont-de-Marsan',
  country: 'FR',
  cornerNW: {
    latitude: 43.8934850,
    longitude: -0.4997820
  },
  cornerSE: {
    latitude: 43.8934850,
    longitude: -0.4997820
  },
  subZones: [{
    name: '40 - Mont-de-Marsan',
    zipcodes: {
      40000: {
        label: 'Mont-de-Marsan'
      }
    }
  }]
}, {
  id: 'MONTLUCON',
  name: 'Montluçon',
  country: 'FR',
  cornerNW: {
    latitude: 46.3400296,
    longitude: 2.6073963
  },
  cornerSE: {
    latitude: 46.3400296,
    longitude: 2.6073963
  },
  deliveryFee: 5,
  subZones: [{
    name: '03 - Montluçon',
    zipcodes: {
      '03100': {
        label: 'Montluçon'
      },
      '03200': {
        label: 'Vichy'
      },
      '03300': {
        label: '03300'
      }
    }
  }]
}, {
  id: 'MONTPELLIER',
  name: 'Montpellier',
  country: 'FR',
  cornerNW: {
    latitude: 43.650133,
    longitude: 3.800002
  },
  cornerSE: {
    latitude: 43.567851,
    longitude: 3.945227
  },
  deliveryFee: 5,
  subZones: [{
    name: '34 - Montpellier',
    zipcodes: {
      34000: {
        label: 'Montpellier',
        intervalForFirstSlotInHours: 4
      },
      34070: {
        label: 'Montpellier',
        intervalForFirstSlotInHours: 4
      },
      34080: {
        label: 'Montpellier',
        intervalForFirstSlotInHours: 4
      },
      34090: {
        label: 'Montpellier',
        intervalForFirstSlotInHours: 4
      }
    }
  }, {
    name: '34 - Montpellier Alentours',
    zipcodes: {
      34170: {
        label: 'Castelnau-le-Lez'
      },
      34430: {
        label: 'Saint-Jean-de-Védas'
      },
      34570: {
        label: 'Pignan Montarnaud Vailhauquès Sa'
      },
      34680: {
        label: "Saint-Georges-d'Orques"
      },
      34730: {
        label: 'Prades-le-Lez Saint-Vincent-de-B'
      },
      34740: {
        label: 'Vendargues'
      },
      34790: {
        label: 'Grabels'
      },
      34830: {
        label: 'Jacou Clapiers'
      },
      34880: {
        label: 'Lavérune'
      },
      34920: {
        label: 'Crès'
      },
      34980: {
        label: 'Saint-Gély-du-Fesc Saint-Clément'
      },
      34990: {
        label: 'Juvignac'
      }
    }
  }, {
    name: '34 - Montpellier Route des Plages',
    zipcodes: {
      34280: {
        label: 'La Grande Motte'
      },
      34470: {
        label: 'Pérols'
      },
      34750: {
        label: 'Villeneuve-lès-Maguelone'
      },
      34970: {
        label: 'Lattes'
      }
    }
  }, {
    name: '34 - Béziers',
    zipcodes: {
      34500: {
        label: 'Béziers'
      }
    }
  }]
}, {
  id: 'MULHOUSE',
  name: 'Mulhouse',
  country: 'FR',
  cornerNW: {
    latitude: 47.750839,
    longitude: 7.335888
  },
  cornerSE: {
    latitude: 47.750839,
    longitude: 7.335888
  },
  deliveryFee: 5,
  subZones: [{
    name: '68 - Mulhouse',
    zipcodes: {
      68000: {
        label: 'Colmar'
      },
      68100: {
        label: 'Mulhouse'
      },
      68110: {
        label: 'Illzach'
      },
      68125: {
        label: 'Houssen'
      },
      68200: {
        label: 'Mulhouse'
      },
      68300: {
        label: 'Saint-Louis'
      },
      68310: {
        label: 'Wittelsheim'
      },
      68400: {
        label: 'Riedisheim'
      },
      68500: {
        label: 'Guebwiller'
      },
      68700: {
        label: 'Cernay'
      },
      68800: {
        label: 'Thann'
      },
      68920: {
        label: 'Wettolsheim'
      },
      68950: {
        label: '68950'
      }
    }
  }]
}, {
  id: 'NANTES',
  name: 'Nantes',
  country: 'FR',
  cornerNW: {
    latitude: 47.294231,
    longitude: -1.658592
  },
  cornerSE: {
    latitude: 47.180026,
    longitude: -1.467359
  },
  deliveryFee: 5,
  subZones: [{
    name: '44 - Nantes',
    zipcodes: {
      44000: {
        label: 'Nantes',
        intervalForFirstSlotInHours: 4
      },
      44036: {
        label: 'Nantes',
        intervalForFirstSlotInHours: 4
      },
      44100: {
        label: 'Nantes',
        intervalForFirstSlotInHours: 4
      },
      44115: {
        label: 'Basse-Goulaine Haute-Goulaine',
        deliveryFee: 15
      },
      44120: {
        label: 'Vertou',
        deliveryFee: 15
      },
      44130: {
        label: 'Blain'
      },
      44200: {
        label: 'Nantes',
        deliveryFee: 15
      },
      44230: {
        label: 'Saint-Sébastien-sur-Loire',
        deliveryFee: 15
      },
      44240: {
        label: 'La Chapelle-sur-Erdre',
        deliveryFee: 15
      },
      44300: {
        label: 'Nantes',
        deliveryFee: 15
      },
      44321: {
        label: 'Nantes'
      },
      44325: {
        label: 'Nantes'
      },
      44330: {
        label: 'Le Pallet'
      },
      44340: {
        label: 'Bouguenais Les Couêts'
      },
      44400: {
        label: 'Rezé Pont-Rousseau'
      },
      44470: {
        label: 'Carquefou Thouaré-sur-Loire Mauv',
        deliveryFee: 15
      },
      44700: {
        label: 'Orvault'
      },
      44800: {
        label: 'Saint-Herblain'
      },
      44840: {
        label: 'Sorinières',
        deliveryFee: 15
      },
      44980: {
        label: 'Sainte-Luce-sur-Loire',
        deliveryFee: 15
      }
    }
  }]
}, {
  id: 'NICE',
  name: 'Nice',
  country: 'FR',
  cornerNW: {
    latitude: 43.759855,
    longitude: 7.165954
  },
  cornerSE: {
    latitude: 43.640979,
    longitude: 7.348775
  },
  deliveryFee: 5,
  subZones: [{
    name: '06 - Nice',
    zipcodes: {
      '06000': {
        label: 'Nice'
      },
      '06100': {
        label: 'Nice'
      },
      '06200': {
        label: 'Nice',
        intervalForFirstSlotInHours: 4
      },
      '06800': {
        label: 'Cagnes sur mer'
      }
    }
  }, {
    name: '06 - Nice Ouest',
    zipcodes: {
      '06700': {
        label: 'Saint-Laurent-du-Var'
      }
    }
  }]
}, {
  id: 'NIMES',
  name: 'Nimes / Avignon',
  country: 'FR',
  cornerNW: {
    latitude: 43.836699,
    longitude: 4.360054
  },
  cornerSE: {
    latitude: 43.836699,
    longitude: 4.360054
  },
  deliveryFee: 5,
  subZones: [{
    name: '30 - Nimes',
    zipcodes: {
      30000: {
        label: 'Nimes'
      },
      30900: {
        label: 'Nimes'
      }
    }
  }, {
    name: '84 - Avignon',
    zipcodes: {
      84000: {
        label: 'Avignon'
      },
      84140: {
        label: 'Avignon'
      }
    }
  }]
}, {
  id: 'NIORT',
  name: 'Niort',
  country: 'FR',
  cornerNW: {
    latitude: 46.3239233,
    longitude: 0.4646064
  },
  cornerSE: {
    latitude: 46.3239233,
    longitude: 0.4646064
  },
  deliveryFee: 5,
  subZones: [{
    name: '79 - Niort',
    zipcodes: {
      79000: {
        label: 'Niort'
      },
      79100: {
        label: 'Thouars'
      },
      79300: {
        label: 'Bressuire'
      },
      79400: {
        label: 'Saint-Maixent-l’École'
      },
      79600: {
        label: 'Parthenay'
      }
    }
  }]
}, {
  id: 'OISE',
  name: 'Oise',
  country: 'FR',
  cornerNW: {
    latitude: 49.41008273189891,
    longitude: 2.425048734674675
  },
  cornerSE: {
    latitude: 49.41008273189891,
    longitude: 2.425048734674675
  },
  deliveryFee: 5,
  subZones: [{
    name: '60 - Compiègne',
    zipcodes: {
      60200: {
        label: 'Compiègne'
      },
      60280: {
        label: 'Margny-lès-Compiègne Venette'
      },
      60880: {
        label: 'Jaux'
      }
    }
  }, {
    name: '60 - Creil',
    zipcodes: {
      60100: {
        label: 'Creil'
      },
      60300: {
        label: 'Senlis'
      }
    }
  }]
}, {
  id: 'ORLEANS',
  name: 'Orléans',
  country: 'FR',
  cornerNW: {
    latitude: 47.902964,
    longitude: 1.909251
  },
  cornerSE: {
    latitude: 47.902964,
    longitude: 1.909251
  },
  deliveryFee: 5,
  subZones: [{
    name: '45 - Orléans',
    zipcodes: {
      45000: {
        label: 'Orléans'
      },
      45100: {
        label: 'Orléans'
      },
      45140: {
        label: 'Saint-Jean-de-Braye'
      },
      45160: {
        label: 'Olivet'
      },
      45400: {
        label: 'Fleury-les-Aubrais'
      },
      45430: {
        label: 'Chécy'
      },
      45750: {
        label: 'Saint-Pryvé-Saint-Mesmin'
      },
      45770: {
        label: 'Saran'
      },
      45800: {
        label: 'Saint-Jean-de-Braye'
      },
      45900: {
        label: '45900'
      }
    }
  }]
}, {
  id: 'PARIS',
  name: 'Île-de-France',
  country: 'FR',
  cornerNW: {
    latitude: 48.93651176701517,
    longitude: 2.151506593360409
  },
  cornerSE: {
    latitude: 48.794001357725215,
    longitude: 2.500322511329159
  },
  deliveryFee: 5,
  subZones: [{
    name: '75 - Paris Hypercentre',
    zipcodes: {
      75001: {
        label: 'Paris 1',
        intervalForFirstSlotInHours: 4
      },
      75002: {
        label: 'Paris 2 ',
        intervalForFirstSlotInHours: 4
      },
      75003: {
        label: 'Paris 3',
        intervalForFirstSlotInHours: 4
      },
      75004: {
        label: 'Paris 4',
        intervalForFirstSlotInHours: 4
      }
    }
  }, {
    name: '75 - Paris Sud Est',
    zipcodes: {
      75005: {
        label: 'Paris 5',
        intervalForFirstSlotInHours: 4
      },
      75012: {
        label: 'Paris 12',
        intervalForFirstSlotInHours: 4
      },
      75013: {
        label: 'Paris 13',
        intervalForFirstSlotInHours: 4
      },
      75020: {
        label: 'Paris 20',
        intervalForFirstSlotInHours: 4
      },
      94160: {
        label: 'Saint Mandé'
      },
      94200: {
        label: 'Ivry-sur-Seine'
      },
      94250: {
        label: 'Kremlin-Bicêtre (1) Gentilly'
      },
      94800: {
        label: 'Villejuif'
      }
    }
  }, {
    name: '75 - Paris Rive Gauche',
    zipcodes: {
      75006: {
        label: 'Paris 6',
        intervalForFirstSlotInHours: 4
      },
      75014: {
        label: 'Paris 14',
        intervalForFirstSlotInHours: 4
      },
      92120: {
        label: 'Montrouge'
      },
      92170: {
        label: 'Vanves (1)'
      },
      92240: {
        label: 'Malakoff Vanves (2)'
      },
      92320: {
        label: 'Châtillon'
      }
    }
  }, {
    name: '75 - Paris Sud Ouest',
    zipcodes: {
      75007: {
        label: 'Paris 7',
        intervalForFirstSlotInHours: 4
      },
      75015: {
        label: 'Paris 15',
        intervalForFirstSlotInHours: 4
      },
      75016: {
        label: 'Paris 16',
        intervalForFirstSlotInHours: 4
      },
      92100: {
        label: 'Boulogne-Billancourt'
      },
      92130: {
        label: 'Issy-les-Moulineaux'
      }
    }
  }, {
    name: '75 - Paris Nord Ouest',
    zipcodes: {
      75008: {
        label: 'Paris 8',
        intervalForFirstSlotInHours: 4
      },
      75009: {
        label: 'Paris 9',
        intervalForFirstSlotInHours: 4
      },
      75017: {
        label: 'Paris 17',
        intervalForFirstSlotInHours: 4
      },
      75116: {
        label: 'Paris 16 (2)',
        intervalForFirstSlotInHours: 4
      },
      92200: {
        label: 'Neuilly'
      },
      92230: {
        label: 'Gennevilliers',
        deliveryFee: 15
      },
      92600: {
        label: 'Asnières',
        deliveryFee: 15
      }
    }
  }, {
    name: '75 - Paris Nord / Nord Est',
    zipcodes: {
      75010: {
        label: 'Paris 10',
        intervalForFirstSlotInHours: 4
      },
      75011: {
        label: 'Paris 11',
        intervalForFirstSlotInHours: 4
      },
      75018: {
        label: 'Paris 18',
        intervalForFirstSlotInHours: 4
      },
      75019: {
        label: 'Paris 19',
        intervalForFirstSlotInHours: 4
      },
      92110: {
        label: 'Clichy'
      },
      92300: {
        label: 'Levallois'
      },
      93000: {
        label: 'Bobigny',
        deliveryFee: 15
      },
      93100: {
        label: 'Montreuil'
      },
      93110: {
        label: 'Rosny-sous-Bois'
      },
      93120: {
        label: 'La Courneuve',
        deliveryFee: 15
      },
      93170: {
        label: 'Bagnolet',
        deliveryFee: 15
      },
      93260: {
        label: 'Les Lilas'
      },
      93300: {
        label: 'Aubervilliers',
        deliveryFee: 15
      },
      93400: {
        label: 'Saint-Ouen'
      },
      93420: {
        label: 'Villepinte'
      },
      93500: {
        label: 'Pantin',
        deliveryFee: 15
      },
      94300: {
        label: 'Vincennes'
      }
    }
  }, {
    name: '77 - Seine-et-Marne',
    zipcodes: {
      77111: {
        label: 'Soignolles-en-Brie Solers',
        deliveryFee: 15
      },
      77127: {
        label: 'Carré Sénart'
      },
      77135: {
        label: 'Pontcarré',
        deliveryFee: 15
      },
      77144: {
        label: 'Chalifert Montévrain',
        deliveryFee: 15
      },
      77150: {
        label: 'Férolles-Attilly Lésigny',
        deliveryFee: 15
      },
      77163: {
        label: 'Dammartin-sur-Tigeaux Mortcerf T',
        deliveryFee: 15
      },
      77164: {
        label: 'Ferrières-en-Brie',
        deliveryFee: 15
      },
      77166: {
        label: 'Évry-Grégy-sur-Yerre Grisy-Suisn',
        deliveryFee: 15
      },
      77170: {
        label: 'Brie-Comte-Robert Servon Coubert',
        deliveryFee: 15
      },
      77173: {
        label: 'Chevry-Cossigny',
        deliveryFee: 15
      },
      77174: {
        label: 'Villeneuve-le-Comte Villeneuve-S',
        deliveryFee: 15
      },
      77177: {
        label: 'Brou-sur-Chantereine',
        deliveryFee: 15
      },
      77181: {
        label: 'Courtry Le Pin',
        deliveryFee: 15
      },
      77183: {
        label: 'Croissy-Beaubourg',
        deliveryFee: 15
      },
      77184: {
        label: 'Émerainville',
        deliveryFee: 15
      },
      77186: {
        label: 'Noisiel',
        deliveryFee: 15
      },
      77200: {
        label: 'Torcy',
        deliveryFee: 15
      },
      77220: {
        label: 'Favières Gretz-Armainvilliers Li',
        deliveryFee: 15
      },
      77300: {
        label: 'Fontainebleau'
      },
      77330: {
        label: 'Ozoir-la-Ferrière',
        deliveryFee: 15
      },
      77340: {
        label: 'Pontault-Combault',
        deliveryFee: 15
      },
      77360: {
        label: 'Vaires-sur-Marne',
        deliveryFee: 15
      },
      77400: {
        label: 'Carnetin Dampmart Gouvernes Lagn',
        deliveryFee: 15
      },
      77420: {
        label: 'Champs-sur-Marne',
        deliveryFee: 15
      },
      77500: {
        label: 'Chelles',
        deliveryFee: 15
      },
      77600: {
        label: 'Bussy-Saint-Martin Chanteloup-en',
        deliveryFee: 15
      },
      77610: {
        label: 'Les Chapelles-Bourbon Châtres Cr',
        deliveryFee: 15
      },
      77680: {
        label: 'Roissy-en-Brie',
        deliveryFee: 15
      },
      77700: {
        label: 'Val d’ Europe'
      },
      77190: {
        label: 'Rosny II'
      }
    }
  }, {
    name: '78 - Paris-Yvelines',
    zipcodes: {
      78000: {
        label: 'Versailles',
        deliveryFee: 15
      },
      78100: {
        label: 'Saint Germain-en-Laye'
      },
      78110: {
        label: 'Le Vesinet'
      },
      78125: {
        label: 'Gazeran'
      },
      78130: {
        label: 'Chapet'
      },
      78140: {
        label: 'Vélizy',
        deliveryFee: 15
      },
      78150: {
        label: 'Chesnay',
        deliveryFee: 15
      },
      78180: {
        label: 'Montigny le bretonneux',
        deliveryFee: 15
      },
      78200: {
        label: 'Mantes-la-Jolie'
      },
      78210: {
        label: 'Saint-Cyr-l’École',
        deliveryFee: 15
      },
      78230: {
        label: 'Le Pecq'
      },
      78240: {
        label: 'Chambourcy'
      },
      78286: {
        label: 'Guyancourt'
      },
      78300: {
        label: 'Poissy'
      },
      78310: {
        label: 'Maurepas',
        deliveryFee: 15
      },
      78330: {
        label: 'Fontenay le fleury',
        deliveryFee: 15
      },
      78340: {
        label: 'Les Clayes-sous-Bois',
        deliveryFee: 15
      },
      78370: {
        label: 'Plaisir',
        deliveryFee: 15
      },
      78400: {
        label: 'Chatou'
      },
      78410: {
        label: 'Flins sur Seine'
      },
      78440: {
        label: 'Gargenville'
      },
      78490: {
        label: 'Monfort-l’Amaury'
      },
      78510: {
        label: 'Triel sur seine'
      },
      78540: {
        label: 'Vernouillet'
      },
      78560: {
        label: 'Le Port-Marly'
      },
      78600: {
        label: 'Maisons-Laffitte',
        deliveryFee: 15
      },
      78630: {
        label: 'Orgeval'
      },
      78640: {
        label: 'Neauphale-le-chateau'
      },
      78670: {
        label: 'Medan Villennes sur seine'
      },
      78700: {
        label: 'Conflans-Sainte-Honorine'
      }
    }
  }, {
    name: '91 - Essonne',
    zipcodes: {
      91000: {
        label: 'Évry-Courcouronnes'
      },
      91080: {
        label: 'Évry-Courcouronnes'
      },
      91140: {
        label: 'Villebon-sur-Yvette'
      },
      91100: {
        label: 'Corbeil-Essonnes'
      },
      91150: {
        label: 'Étampes'
      },
      91180: {
        label: 'Saint-Germain-lès-Arpajon'
      },
      91220: {
        label: 'Bretigny-sur-Orge'
      },
      91240: {
        label: 'Saint-Michel-sur-orge'
      },
      91260: {
        label: 'Juvisy-sur-orge'
      },
      91290: {
        label: 'Arpajon'
      },
      91300: {
        label: 'Massy'
      },
      91380: {
        label: 'Chilly-Mazarin'
      },
      91410: {
        label: 'Dourdan'
      },
      91520: {
        label: 'Egly'
      },
      91530: {
        label: 'Saint-Chéron'
      },
      91600: {
        label: 'Savigny-sur-Orge'
      },
      91650: {
        label: 'Saint-Yon Breuillet'
      },
      91680: {
        label: 'Bruyères-le-Châtel'
      },
      91700: {
        label: 'Villier-sur-Orge'
      },
      91860: {
        label: 'Épinay-sous-Sénart'
      }
    }
  }, {
    name: '92 - Hauts-de-Seine',
    zipcodes: {
      92000: {
        label: 'Nanterre',
        deliveryFee: 15
      },
      92092: {
        label: 'La Défense'
      },
      92140: {
        label: 'Clamart',
        deliveryFee: 15
      },
      92150: {
        label: 'Suresnes',
        deliveryFee: 15
      },
      92160: {
        label: 'Antony',
        deliveryFee: 15
      },
      92190: {
        label: 'Meudon (1)',
        deliveryFee: 15
      },
      92210: {
        label: 'St Cloud',
        deliveryFee: 15
      },
      92220: {
        label: 'Bagneux',
        deliveryFee: 15
      },
      92250: {
        label: 'La Garenne Colombes',
        deliveryFee: 15
      },
      92260: {
        label: 'Fontenay-aux-Roses',
        deliveryFee: 15
      },
      92270: {
        label: 'Bois Colombes',
        deliveryFee: 15
      },
      92330: {
        label: 'Sceaux',
        deliveryFee: 15
      },
      92340: {
        label: 'Bourg la Reine',
        deliveryFee: 15
      },
      92350: {
        label: 'Le Plessis-Robinson',
        deliveryFee: 15
      },
      92360: {
        label: 'Meudon (2)',
        deliveryFee: 15
      },
      92380: {
        label: 'Garches',
        deliveryFee: 15
      },
      92390: {
        label: 'Villeneuve-la-Garenne',
        deliveryFee: 15
      },
      92400: {
        label: 'Courbevoie',
        deliveryFee: 15
      },
      92410: {
        label: "Ville d'Avray",
        deliveryFee: 15
      },
      92420: {
        label: 'Vaucresson',
        deliveryFee: 15
      },
      92430: {
        label: 'Marnes la Coquette',
        deliveryFee: 15
      },
      92500: {
        label: 'Rueil-malmaison',
        deliveryFee: 15
      },
      92700: {
        label: 'Colombes',
        deliveryFee: 15
      },
      92800: {
        label: 'Puteaux',
        deliveryFee: 15
      }
    }
  }, {
    name: '93 - Seine-Saint-Denis',
    zipcodes: {
      93130: {
        label: 'Noisy-le-Sec',
        deliveryFee: 15
      },
      93150: {
        label: 'Le Blanc-Mesnil',
        deliveryFee: 15
      },
      93160: {
        label: 'Noisy-le-Grand',
        deliveryFee: 15
      },
      93170: {
        label: 'Bagnolet',
        deliveryFee: 15
      },
      93200: {
        label: 'Saint-Denis (1)',
        deliveryFee: 15
      },
      93210: {
        label: 'La Plaine Saint-Denis Saint-Denis',
        deliveryFee: 15
      },
      93220: {
        label: 'Gagny',
        deliveryFee: 15
      },
      93230: {
        label: 'Romainville',
        deliveryFee: 15
      },
      93260: {
        label: 'Les Lilas'
      },
      93300: {
        label: 'Aubervilliers',
        deliveryFee: 15
      },
      93310: {
        label: 'Le Pré-Saint-Gervais'
      },
      93450: {
        label: "L'Ile Saint-Denis",
        deliveryFee: 15
      },
      93600: {
        label: 'Aulnay'
      },
      93800: {
        label: 'Épinay-sur-Seine'
      }
    }
  }, {
    name: '94 - Val-de-Marne',
    zipcodes: {
      94000: {
        label: 'Créteil'
      },
      94100: {
        label: 'St Maur des fossés'
      },
      94110: {
        label: 'Arcueil',
        deliveryFee: 15
      },
      94120: {
        label: 'Fontenay sous Bois',
        deliveryFee: 15
      },
      94130: {
        label: 'Nogent-sur-Marne',
        deliveryFee: 15
      },
      94140: {
        label: 'Alfortville'
      },
      94190: {
        label: 'Villeneuve st Georges'
      },
      94205: {
        label: 'Ivry-sur-Seine'
      },
      94220: {
        label: 'Charenton le pont'
      },
      94230: {
        label: 'Cachan',
        deliveryFee: 15
      },
      94240: {
        label: "L'Haÿ-les-Roses",
        deliveryFee: 15
      },
      94260: {
        label: 'Fresnes',
        deliveryFee: 15
      },
      94270: {
        label: 'Kremlin-Bicêtre (2)'
      },
      94310: {
        label: 'Orly'
      },
      94320: {
        label: 'Thiais'
      },
      94340: {
        label: 'Joinville le Pont',
        deliveryFee: 15
      },
      94350: {
        label: 'Villiers-sur-Marne',
        deliveryFee: 15
      },
      94360: {
        label: 'Bry-sur-Marne',
        deliveryFee: 15
      },
      94380: {
        label: 'Bonneuil sur marne'
      },
      94400: {
        label: 'Vitry sur Seine'
      },
      94410: {
        label: 'Maison Alfort (1)'
      },
      94420: {
        label: 'Le Plessis-Trévise',
        deliveryFee: 15
      },
      94430: {
        label: 'Chennevières-sur-Marne',
        deliveryFee: 15
      },
      94440: {
        label: 'Santeny Marolles-en-Brie',
        deliveryFee: 15
      },
      94460: {
        label: 'Valenton'
      },
      94470: {
        label: 'Boissy St Léger'
      },
      94480: {
        label: 'Ablon-sur-Seine'
      },
      94490: {
        label: 'Ormesson-sur-Marne',
        deliveryFee: 15
      },
      94500: {
        label: 'Champigny-sur-Marne',
        deliveryFee: 15
      },
      94510: {
        label: 'La Queue-en-Brie',
        deliveryFee: 15
      },
      94520: {
        label: 'Mandres-les-Roses Périgny',
        deliveryFee: 15
      },
      94531: {
        label: 'Belle Épine'
      },
      94550: {
        label: 'Chevilly Larue',
        deliveryFee: 15
      },
      94600: {
        label: 'Choisy le roi'
      },
      94700: {
        label: 'Maison Alfort (2)'
      },
      94880: {
        label: 'Noiseau',
        deliveryFee: 15
      }
    }
  }, {
    name: '95 - Val-d’Oise',
    zipcodes: {
      95000: {
        label: 'Cergy, Neuville-sur-Oise'
      },
      95100: {
        label: 'Argenteuil'
      },
      95120: {
        label: 'Ermont'
      },
      95130: {
        label: 'Franconville'
      },
      95150: {
        label: 'Taverny'
      },
      95200: {
        label: 'Sarcelles'
      },
      95240: {
        label: 'Cormeilles-en-Parisis'
      },
      95290: {
        label: 'L’Isle-Adam'
      },
      95350: {
        label: 'Saint-Brice-sous-Forêt'
      },
      95370: {
        label: 'Montigny-lès-Cormeilles'
      },
      95490: {
        label: '95490'
      },
      95600: {
        label: 'Eaubonne'
      },
      95630: {
        label: 'Mériel'
      },
      95870: {
        label: 'Bezons'
      }
    }
  }]
}, {
  id: 'PAU',
  name: 'Pau',
  country: 'FR',
  cornerNW: {
    latitude: 43.2951,
    longitude: -0.370797
  },
  cornerSE: {
    latitude: 43.2951,
    longitude: -0.370797
  },
  deliveryFee: 5,
  subZones: [{
    name: '64 - Pau',
    zipcodes: {
      64000: {
        label: 'Pau'
      }
    }
  }]
}, {
  id: 'PERPIGNAN',
  name: 'Perpignan',
  country: 'FR',
  cornerNW: {
    latitude: 42.6985304,
    longitude: 2.8953121
  },
  cornerSE: {
    latitude: 42.6985304,
    longitude: 2.8953121
  },
  deliveryFee: 5,
  subZones: [{
    name: '66 - Perpignan',
    zipcodes: {
      66000: {
        label: 'Perpignan'
      },
      66100: {
        label: 'Perpignan'
      },
      66200: {
        label: 'Elne'
      },
      66300: {
        label: 'Thuir'
      },
      66400: {
        label: 'Céret'
      },
      66500: {
        label: 'Prades'
      },
      66750: {
        label: 'Saint-Cyprien'
      },
      66900: {
        label: '66900'
      }
    }
  }]
}, {
  id: 'POITIERS',
  name: 'Poitiers',
  country: 'FR',
  cornerNW: {
    latitude: 46.580224,
    longitude: 0.340375
  },
  cornerSE: {
    latitude: 46.580224,
    longitude: 0.340375
  },
  deliveryFee: 5,
  subZones: [{
    name: '86 - Poitiers',
    zipcodes: {
      86000: {
        label: 'Poitiers'
      }
    }
  }]
}, {
  id: 'QUIMPER',
  name: 'Quimper',
  country: 'FR',
  cornerNW: {
    latitude: 47.997542,
    longitude: -4.097899
  },
  cornerSE: {
    latitude: 47.997542,
    longitude: -4.097899
  },
  subZones: [{
    name: '29 - Quimper',
    zipcodes: {
      29000: {
        label: 'Quimper'
      }
    }
  }]
}, {
  id: 'REIMS',
  name: 'Reims',
  country: 'FR',
  cornerNW: {
    latitude: 49.258329,
    longitude: 4.031696
  },
  cornerSE: {
    latitude: 49.258329,
    longitude: 4.031696
  },
  deliveryFee: 5,
  subZones: [{
    name: '51 - Reims',
    zipcodes: {
      51100: {
        label: 'Reims'
      }
    }
  }]
}, {
  id: 'RENNES',
  name: 'Rennes',
  country: 'FR',
  cornerNW: {
    latitude: 48.147974,
    longitude: -1.754889
  },
  cornerSE: {
    latitude: 48.077577,
    longitude: -1.616839
  },
  deliveryFee: 5,
  subZones: [{
    name: '35 - Rennes Centre',
    zipcodes: {
      35000: {
        label: 'Rennes',
        intervalForFirstSlotInHours: 4
      },
      35055: {
        label: 'Rennes',
        intervalForFirstSlotInHours: 4
      },
      35066: {
        label: 'Rennes',
        intervalForFirstSlotInHours: 4
      },
      35200: {
        label: 'Rennes',
        intervalForFirstSlotInHours: 4
      },
      35700: {
        label: 'Rennes'
      }
    }
  }, {
    name: '35 - Rennes Est',
    zipcodes: {
      35510: {
        label: 'Cesson-Sévigné'
      },
      35540: {
        label: 'Pacé'
      }
    }
  }, {
    name: '35 - Rennes Nord',
    zipcodes: {
      35235: {
        label: 'Thorigné-Fouillard'
      },
      35520: {
        label: 'Melesse Chapelle-des-Fougeretz M'
      },
      35740: {
        label: 'Pacé'
      },
      35760: {
        label: 'Saint-Grégoire Montgermont'
      },
      35830: {
        label: 'Betton'
      }
    }
  }, {
    name: '35 - Rennes Ouest',
    zipcodes: {
      35132: {
        label: 'Vezin-le-Coquet'
      },
      35650: {
        label: 'Rheu Moigné'
      }
    }
  }, {
    name: '35 - Rennes Sud',
    zipcodes: {
      35131: {
        label: 'Chartres-de-Bretagne Pont-péan'
      },
      35135: {
        label: 'Chantepie'
      },
      35136: {
        label: 'Saint-Jacques-de-la-Lande'
      },
      35170: {
        label: 'Bruz'
      },
      35281: {
        label: 'Saint-Jacques-de-la-Lande'
      },
      35770: {
        label: 'Vern-sur-Seiche'
      }
    }
  }]
}, {
  id: 'ROUEN',
  name: 'Rouen',
  country: 'FR',
  cornerNW: {
    latitude: 49.469254,
    longitude: 1.027657
  },
  cornerSE: {
    latitude: 49.417257,
    longitude: 1.153315
  },
  deliveryFee: 5,
  subZones: [{
    name: '76 - Rouen',
    zipcodes: {
      76000: {
        label: 'Rouen',
        intervalForFirstSlotInHours: 4
      },
      76100: {
        label: 'Rouen',
        intervalForFirstSlotInHours: 4
      },
      76120: {
        label: 'Grand-Quevilly'
      },
      76130: {
        label: 'Mont-Saint-Aignan'
      },
      76140: {
        label: 'Petit-Quevilly'
      },
      76150: {
        label: 'Maromme Saint-Jean-du-Cardonnay'
      },
      76160: {
        label: 'St Léger du Bourg Denis'
      },
      76190: {
        label: '76190'
      },
      76230: {
        label: 'Bois-Guillaume Quincampoix Isnea'
      },
      76240: {
        label: 'Bonsecours Mesnil-Esnard Belbeuf'
      },
      76250: {
        label: 'Déville-lès-Rouen'
      },
      76300: {
        label: 'Sotteville-lès-Rouen'
      },
      76360: {
        label: 'Barentin'
      },
      76380: {
        label: 'Canteleu Montigny Val-de-la-Haye'
      },
      76420: {
        label: 'Bihorel'
      },
      76480: {
        label: 'Duclair Saint-Pierre-de-Varengeville'
      },
      76530: {
        label: '76530'
      },
      76650: {
        label: 'Petit-Couronne'
      },
      76770: {
        label: 'Malaunay Houlme Houppeville'
      },
      76800: {
        label: 'Saint-Étienne-du-Rouvray'
      },
      76840: {
        label: 'Saint-Martin-de-Boscherville Hénouville'
      },
      76920: {
        label: 'Amfreville-la-Mi-Voie'
      },
      76960: {
        label: 'Notre-Dame-de-Bondeville'
      }
    }
  }]
}, {
  id: 'SAINT_BRIEUC',
  name: 'Saint-Brieuc',
  country: 'FR',
  cornerNW: {
    latitude: 48.534,
    longitude: 2.822
  },
  cornerSE: {
    latitude: 48.485,
    longitude: 2.711
  },
  deliveryFee: 5,
  subZones: [{
    name: '22 - Saint-Brieuc',
    zipcodes: {
      22000: {
        label: 'Saint-Brieuc'
      },
      22100: {
        label: 'Dinan'
      },
      22200: {
        label: 'Guingamp'
      },
      22300: {
        label: 'Lannion'
      },
      22360: {
        label: 'Langueux'
      },
      22400: {
        label: 'Lamballe'
      }
    }
  }, {
    name: '22 - Loudéac',
    zipcodes: {
      22600: {
        label: 'Loudéac'
      }
    }
  }, {
    name: '22 - Paimpol',
    zipcodes: {
      22500: {
        label: 'Paimpol'
      }
    }
  }]
}, {
  id: 'SAINT_ETIENNE',
  name: 'Saint-Etienne',
  country: 'FR',
  cornerNW: {
    latitude: 45.444,
    longitude: 4.378
  },
  cornerSE: {
    latitude: 45.424,
    longitude: 4.418
  },
  deliveryFee: 5,
  subZones: [{
    name: '42 - Saint-Etienne',
    zipcodes: {
      42000: {
        label: 'Saint-Étienne'
      },
      42100: {
        label: 'Saint-Étienne'
      },
      42120: {
        label: 'Le Coteau'
      },
      42210: {
        label: 'Montrond-les-Bains'
      },
      42300: {
        label: 'Roanne'
      },
      42400: {
        label: 'Saint-Chamond'
      },
      42500: {
        label: '42500'
      },
      42650: {
        label: 'Saint-Etienne'
      }
    }
  }]
}, {
  id: 'SAINT_MALO',
  name: 'Saint-Malo',
  country: 'FR',
  cornerNW: {
    latitude: 48.6492210,
    longitude: -2.0184218
  },
  cornerSE: {
    latitude: 48.6492210,
    longitude: -2.0184218
  },
  subZones: [{
    name: '35 - Saint-Malo',
    zipcodes: {
      22100: {
        label: 'Dinan'
      },
      35400: {
        label: 'Saint-Malo'
      },
      35800: {
        label: 'Dinard'
      },
      35780: {
        label: 'Le Richardais'
      },
      50170: {
        label: 'Beauvoir'
      }
    }
  }]
}, {
  id: 'SAINT_NAZAIRE',
  name: 'Saint Nazaire',
  country: 'FR',
  cornerNW: {
    latitude: 47.273498,
    longitude: -2.213848
  },
  cornerSE: {
    latitude: 47.273498,
    longitude: -2.213848
  },
  deliveryFee: 5,
  subZones: [{
    name: '44 - Saint-Nazaire',
    zipcodes: {
      44600: {
        label: 'Saint Nazaire'
      },
      44380: {
        label: 'Pornichet'
      }
    }
  }]
}, {
  id: 'SAINT_QUENTIN',
  name: 'Saint-Quentin',
  country: 'FR',
  cornerNW: {
    latitude: 49.848171,
    longitude: 3.288170
  },
  cornerSE: {
    latitude: 49.848171,
    longitude: 3.288170
  },
  deliveryFee: 5,
  subZones: [{
    name: '02 - Saint-Quentin',
    zipcodes: {
      '02100': {
        label: 'Saint-Quentin'
      }
    }
  }]
}, {
  id: 'STRASBOURG',
  name: 'Strasbourg',
  country: 'FR',
  cornerNW: {
    latitude: 48.641852,
    longitude: 7.678665
  },
  cornerSE: {
    latitude: 48.493156,
    longitude: 7.841057
  },
  deliveryFee: 5,
  subZones: [{
    name: '67 - Strasbourg',
    zipcodes: {
      67000: {
        label: 'Strasbourg',
        intervalForFirstSlotInHours: 4
      },
      67100: {
        label: 'Strasbourg',
        intervalForFirstSlotInHours: 4
      },
      67114: {
        label: 'Eschau'
      },
      67116: {
        label: 'Reichstett'
      },
      67118: {
        label: 'Geispolsheim'
      },
      67200: {
        label: 'Strasbourg',
        intervalForFirstSlotInHours: 4
      },
      67201: {
        label: 'Eckbolsheim'
      },
      67202: {
        label: 'Wolfisheim'
      },
      67203: {
        label: 'Oberschaeffolsheim'
      },
      67204: {
        label: 'Achenheim'
      },
      67205: {
        label: 'Oberhausbergen'
      },
      67206: {
        label: 'Mittelhausbergen'
      },
      67207: {
        label: 'Niederhausbergen'
      },
      67300: {
        label: 'Schiltigheim'
      },
      67380: {
        label: 'Lingolsheim'
      },
      67400: {
        label: 'Illkirch-Graffenstaden'
      },
      67450: {
        label: 'Mundolsheim Lampertheim'
      },
      67460: {
        label: 'Souffelweyersheim'
      },
      67540: {
        label: 'Ostwald'
      },
      67800: {
        label: 'Bischheim Hoenheim'
      },
      67810: {
        label: 'Holtzheim'
      },
      67960: {
        label: 'Entzheim'
      }
    }
  }]
}, {
  id: 'TOULON',
  name: 'Toulon',
  country: 'FR',
  cornerNW: {
    latitude: 43.124228,
    longitude: 5.928
  },
  cornerSE: {
    latitude: 43.124228,
    longitude: 5.928
  },
  deliveryFee: 5,
  subZones: [{
    name: '83 - Toulon',
    zipcodes: {
      83000: {
        label: 'Toulon'
      },
      83100: {
        label: 'Toulon'
      },
      83110: {
        label: 'Sanary-sur-Mer'
      },
      83130: {
        label: 'La Garde'
      },
      83150: {
        label: 'Bandol'
      },
      83160: {
        label: 'La Valette-du-Var'
      },
      83270: {
        label: 'Saint-Cyr-sur-Mer'
      },
      83330: {
        label: 'Le Beausset'
      },
      83400: {
        label: 'Hyères'
      },
      83500: {
        label: 'La Seyne-sur-Mer'
      }
    }
  }]
}, {
  id: 'TOULOUSE',
  name: 'Toulouse',
  country: 'FR',
  cornerNW: {
    latitude: 43.670128,
    longitude: 1.336365
  },
  cornerSE: {
    latitude: 43.531522,
    longitude: 1.516954
  },
  deliveryFee: 5,
  subZones: [{
    name: '31 - Toulouse',
    zipcodes: {
      31000: {
        label: 'Toulouse',
        intervalForFirstSlotInHours: 4
      },
      31004: {
        label: 'Toulouse',
        intervalForFirstSlotInHours: 4
      },
      31090: {
        label: 'Toulouse'
      }
    }
  }, {
    name: '31 - Toulouse Est',
    zipcodes: {
      31043: {
        label: 'Toulouse',
        intervalForFirstSlotInHours: 4
      },
      31500: {
        label: 'Toulouse',
        intervalForFirstSlotInHours: 4
      }
    }
  }, {
    name: '31 - Toulouse Sud',
    zipcodes: {
      31100: {
        label: 'Toulouse'
      },
      31270: {
        label: 'Cugnaux Villeneuve-Tolosane Frou'
      },
      31400: {
        label: 'Toulouse'
      },
      31520: {
        label: 'Ramonville'
      }
    }
  }, {
    name: '31 - Toulouse Nord',
    zipcodes: {
      31140: {
        label: 'Aucamville Saint-Alban Launaguet'
      },
      31180: {
        label: 'Castelmaurou Saint-Génies-Bellev'
      },
      31200: {
        label: 'Toulouse'
      },
      31240: {
        label: "L'Union Saint Jean"
      },
      31380: {
        label: 'Garidech Gémil Montastruc-la-Con'
      },
      31660: {
        label: 'Bessières Buzet-sur-Tarn'
      }
    }
  }, {
    name: '31 - Toulouse Ouest',
    zipcodes: {
      31170: {
        label: 'Tournefeuille'
      },
      31300: {
        label: 'Toulouse',
        intervalForFirstSlotInHours: 4
      },
      31770: {
        label: 'Colomiers'
      },
      31850: {
        label: 'Mondouzil Montrabé Beaupuy'
      }
    }
  }, {
    name: '31 - Toulouse Sud Est',
    zipcodes: {
      31650: {
        label: 'Saint Orens'
      },
      31670: {
        label: 'Labège'
      },
      31700: {
        label: 'Blagnac Beauzelle Cornebarrieu M'
      },
      31750: {
        label: 'Escalquens'
      },
      31770: {
        label: 'Colomiers'
      }
    }
  }, {
    name: '31 - Toulouse Roques',
    zipcodes: {
      31120: {
        label: 'Toulouse Roques'
      }
    }
  }]
}, {
  id: 'TOURS',
  name: 'Tours',
  country: 'FR',
  cornerNW: {
    latitude: 47.44036,
    longitude: 0.650306
  },
  cornerSE: {
    latitude: 47.347643,
    longitude: 0.739915
  },
  deliveryFee: 5,
  subZones: [{
    name: '37 - Tours',
    zipcodes: {
      37000: {
        label: 'TOURS',
        intervalForFirstSlotInHours: 4
      },
      37100: {
        label: 'TOURS',
        intervalForFirstSlotInHours: 4
      },
      37170: {
        label: 'Chambray-lès-Tours'
      },
      37200: {
        label: 'Tours'
      },
      37230: {
        label: 'Fondettes Luynes Saint-Étienne-d'
      },
      37250: {
        label: 'Montbazon Sorigny Veigné'
      },
      37300: {
        label: 'Joué-lés-Tours'
      },
      37510: {
        label: 'Ballan-Miré Savonnières Saint-Ge'
      },
      37520: {
        label: 'Riche'
      },
      37540: {
        label: 'Saint-Cyr-sur-Loire'
      },
      37550: {
        label: 'Saint-Avertin'
      },
      37700: {
        label: 'Saint-Pierre-des-Corps Ville-aux'
      }
    }
  }]
}, {
  id: 'TROYES',
  name: 'Troyes',
  country: 'FR',
  cornerNW: {
    latitude: 48.2975056,
    longitude: 4.0746921
  },
  cornerSE: {
    latitude: 48.2975056,
    longitude: 4.0746921
  },
  subZones: [{
    name: '10 - Troyes',
    zipcodes: {
      10000: {
        label: 'Troyes'
      }
    }
  }]
}, {
  id: 'VALENCE',
  name: 'Valence',
  country: 'FR',
  cornerNW: {
    latitude: 44.9336953,
    longitude: 4.8967142
  },
  cornerSE: {
    latitude: 44.9336953,
    longitude: 4.8967142
  },
  subZones: [{
    name: '26 - Valence',
    zipcodes: {
      26362: {
        label: 'Valence'
      }
    }
  }, {
    name: '26 - Valence alentours',
    zipcodes: {
      '07160': {
        label: 'Le Cheylard'
      }
    }
  }]
}, {
  id: 'VALENCIENNES',
  name: 'Valenciennes',
  country: 'FR',
  cornerNW: {
    latitude: 50.357,
    longitude: 3.525
  },
  cornerSE: {
    latitude: 50.357,
    longitude: 3.525
  },
  deliveryFee: 5,
  subZones: [{
    name: '59 - Valenciennes',
    zipcodes: {
      59300: {
        label: 'Valenciennes'
      }
    }
  }]
}, {
  id: 'VESOUL',
  name: 'Vesoul',
  country: 'FR',
  cornerNW: {
    latitude: 47.6197395,
    longitude: 6.1544694
  },
  cornerSE: {
    latitude: 47.6197395,
    longitude: 6.1544694
  },
  deliveryFee: 5,
  subZones: [{
    name: '70 - Vesoul',
    zipcodes: {
      70000: {
        label: 'Vesoul'
      },
      70100: {
        label: 'Gray'
      },
      70200: {
        label: 'Lure'
      },
      70300: {
        label: 'Luxeuil-les-Bains'
      },
      70400: {
        label: 'Héricourt'
      },
      70500: {
        label: '70500'
      }
    }
  }]
}, {
  id: 'CHARTRES',
  name: 'Chartres',
  country: 'FR',
  cornerNW: {
    latitude: 48.4439,
    longitude: 1.4883
  },
  cornerSE: {
    latitude: 48.4439,
    longitude: 1.4883
  },
  subZones: [{
    name: '28 - Chartres',
    zipcodes: {
      28000: {
        label: 'Chartres'
      }
    }
  }]
}, {
  id: 'ROUBAIX',
  name: 'Roubaix',
  country: 'FR',
  cornerNW: {
    latitude: 50.6927,
    longitude: 3.1778
  },
  cornerSE: {
    latitude: 50.6927,
    longitude: 3.1778
  },
  subZones: [{
    name: '59 - Roubaix',
    zipcodes: {
      59100: {
        label: 'Roubaix'
      }
    }
  }]
}, {
  id: 'SAINT_TROPEZ',
  name: 'Saint-Tropez',
  country: 'FR',
  cornerNW: {
    latitude: 43.2694,
    longitude: 6.6389
  },
  cornerSE: {
    latitude: 43.2694,
    longitude: 6.6389
  },
  subZones: [{
    name: '83 - Saint-Tropez',
    zipcodes: {
      83990: {
        label: 'Saint-Tropez'
      }
    }
  }]
}, {
  id: 'BASTIA',
  name: 'Bastia',
  country: 'FR',
  cornerNW: {
    latitude: 42.7028,
    longitude: 9.4500
  },
  cornerSE: {
    latitude: 42.7028,
    longitude: 9.4500
  },
  subZones: [{
    name: '2B - Bastia',
    zipcodes: {
      20200: {
        label: 'Bastia'
      }
    }
  }]
}, {
  id: 'MONT_BLANC',
  name: 'Mont-Blanc',
  country: 'FR',
  cornerNW: {
    latitude: 45.8567,
    longitude: 6.6178
  },
  cornerSE: {
    latitude: 45.8567,
    longitude: 6.6178
  },
  subZones: [{
    name: '74 - Megève',
    zipcodes: {
      74120: {
        label: 'Megève'
      }
    }
  }]
}, {
  id: 'VANOISE',
  name: 'Vanoise',
  country: 'FR',
  cornerNW: {
    latitude: 45.4147,
    longitude: 6.6364
  },
  cornerSE: {
    latitude: 45.4147,
    longitude: 6.6364
  },
  subZones: [{
    name: '73 - Courchevel',
    zipcodes: {
      73120: {
        label: 'Courchevel'
      }
    }
  }]
}];
var frSubZoneNameMapping = exports.frSubZoneNameMapping = [{
  old: 'Paris Hypercentre',
  "new": '75 - Paris Hypercentre'
}, {
  old: 'Paris Sud est',
  "new": '75 - Paris Sud Est'
}, {
  old: 'Paris Rive gauche',
  "new": '75 - Paris Rive Gauche'
}, {
  old: 'Paris Sud ouest',
  "new": '75 - Paris Sud Ouest'
}, {
  old: 'Paris Nord ouest',
  "new": '75 - Paris Nord Ouest'
}, {
  old: 'Paris Nord / Nord est',
  "new": '75 - Paris Nord / Nord Est'
}, {
  old: 'Margny-lès-Compiègne Venette',
  "new": '60 - Compiègne'
}, {
  old: 'Jaux',
  "new": '60 - Compiègne'
}, {
  old: 'Le 77',
  "new": '77 - Seine-et-Marne'
}, {
  old: "L'Oise",
  "new": '60 - Compiègne'
}, {
  old: '60 - Oise',
  "new": '60 - Compiègne'
}, {
  old: 'Le 78',
  "new": '78 - Paris-Yvelines'
}, {
  old: 'YVELINES',
  "new": '78 - Paris-Yvelines'
}, {
  old: '78 - Yvelines',
  "new": '78 - Paris-Yvelines'
}, {
  old: 'AMIENS',
  "new": '80 - Amiens'
}, {
  old: 'Le 91',
  "new": '91 - Essonne'
}, {
  old: 'Le 92',
  "new": '92 - Hauts-de-Seine'
}, {
  old: 'Le 93',
  "new": '93 - Seine-Saint-Denis'
}, {
  old: 'Le 94',
  "new": '94 - Val-de-Marne'
}, {
  old: 'Marseille zone 1',
  "new": '13 - Marseille Hypercentre'
}, {
  old: 'Marseille zone 2',
  "new": '13 - Marseille Centre'
}, {
  old: 'Marseille 7',
  "new": '13 - Marseille 7'
}, {
  old: 'Marseille zone 3',
  "new": '13 - Marseille Sud'
}, {
  old: 'Marseille zone 4 villages',
  "new": '13 - Marseille Nord'
}, {
  old: 'Aix-en-Provence',
  "new": '13 - Aix-en-Provence'
}, {
  old: 'Aix-E-P SUD',
  "new": '13 - Aix-en-Provence Sud'
}, {
  old: 'Aix-E-P NORD',
  "new": '13 - Aix-en-Provence Nord'
}, {
  old: 'Aix-E-P EST',
  "new": '13 - Aix-en-Provence Est'
}, {
  old: 'Aubagne-Gémonos',
  "new": '13 - Aubagne-Gémenos'
}, {
  old: '13 - Aubagne-Gémonos',
  "new": '13 - Aubagne-Gémenos'
}, {
  old: 'Lyon',
  "new": '69 - Lyon'
}, {
  old: 'Lyon Villeurbanne',
  "new": '69 - Lyon Villeurbanne'
}, {
  old: 'Lyon alentours',
  "new": '69 - Lyon Alentours'
}, {
  old: 'Lyon Rileux',
  "new": '69 - Lyon Rilleux'
}, {
  old: '69 - Lyon Rileux',
  "new": '69 - Lyon Rilleux'
}, {
  old: 'Nancy',
  "new": '54 - Nancy'
}, {
  old: 'Metz',
  "new": '57 - Metz'
}, {
  old: 'BORDEAUX',
  "new": '33 - Bordeaux'
}, {
  old: 'BORDEAUX - OUEST',
  "new": '33 - Bordeaux Nord-Ouest'
}, {
  old: 'BORDEAUX - NORD-OUEST',
  "new": '33 - Bordeaux Nord-Ouest'
}, {
  old: '33 - Bordeaux Est',
  "new": '33 - Bordeaux Sud-Est'
}, {
  old: '33 - Bordeaux Nord',
  "new": '33 - Bordeaux Nord-Ouest'
}, {
  old: '33 - Bordeaux Nord Est',
  "new": '33 - Bordeaux Nord-Est'
}, {
  old: '33 - Bordeaux Nord Ouest',
  "new": '33 - Bordeaux Nord-Ouest'
}, {
  old: '33 - Bordeaux Sud',
  "new": '33 - Bordeaux Sud-Ouest'
}, {
  old: '33 - Bordeaux Sud Est',
  "new": '33 - Bordeaux Nord-Est'
}, {
  old: 'RENNES',
  "new": '35 - Rennes Centre'
}, {
  old: '35 - Rennes',
  "new": '35 - Rennes Centre'
}, {
  old: 'NANTES',
  "new": '44 - Nantes'
}, {
  old: 'TOULOUSE',
  "new": '31 - Toulouse'
}, {
  old: 'LILLE Loos / Haubourdin',
  "new": '59 - Lille Loos / Haubourdin'
}, {
  old: 'LILLE NORD EST',
  "new": '59 - Lille Nord Est'
}, {
  old: 'LILLE SECLIN',
  "new": '59 - Lille Seclin'
}, {
  old: 'LILLE NORD OUEST',
  "new": '59 - Lille Nord Ouest'
}, {
  old: 'LILLE SUD',
  "new": '59 - Lille Sud'
}, {
  old: 'LILLE',
  "new": '59 - Lille'
}, {
  old: 'STRASBOURG',
  "new": '67 - Strasbourg'
}, {
  old: 'CANNES',
  "new": '83 - Fréjus'
}, {
  old: 'MONTPELLIER',
  "new": '34 - Montpellier'
}, {
  old: 'ROUEN',
  "new": '76 - Rouen'
}, {
  old: 'CAEN',
  "new": '14 - Caen'
}, {
  old: 'TOUQUET-TROUVILLE',
  "new": '14 - Deauville / Trouville'
}, {
  old: 'TOURS',
  "new": '37 - Tours'
}, {
  old: 'GRENOBLE',
  "new": '38 - Grenoble'
}, {
  old: 'ANNECY',
  "new": '74 - Annecy'
}, {
  old: 'Avignon',
  "new": '84 - Avignon'
}, {
  old: 'Nice',
  "new": '06 - Nice'
}, {
  old: 'Le 95',
  "new": '95 - Val-d’Oise'
}, {
  old: 'Nice Ouest',
  "new": '06 - Nice Ouest'
}, {
  old: 'Ajaccio',
  "new": '20 - Ajaccio'
}, {
  old: 'Angers',
  "new": '49 - Angers'
}, {
  old: 'Angoulême',
  "new": '16 - Angoulême'
}, {
  old: 'Bayonne',
  "new": '64 - Bayonne'
}, {
  old: 'Béziers',
  "new": '34 - Béziers'
}, {
  old: 'Bourge',
  "new": '18 - Bourges'
}, {
  old: 'Brest',
  "new": '29 - Brest'
}, {
  old: 'Calais',
  "new": '62 - Calais'
}, {
  old: 'Clermont-Ferrand',
  "new": '63 - Clermont-Ferrand'
}, {
  old: 'DIJON',
  "new": '21 - Dijon'
}, {
  old: 'Dunkerque',
  "new": '59 - Dunkerque'
}, {
  old: 'La Rochelle',
  "new": '17 - La Rochelle'
}, {
  old: 'Le Havre',
  "new": '76 - Le Havre'
}, {
  old: 'Le Mans',
  "new": '72 - Le Mans'
}, {
  old: 'limoges',
  "new": '87 - Limoges'
}, {
  old: 'Lorient',
  "new": '56 - Lorient'
}, {
  old: '56 - Vannes',
  "new": '56 - Lorient'
}, {
  old: 'Monaco',
  "new": '98 - Monaco'
}, {
  old: 'Mulhouse',
  "new": '68 - Mulhouse'
}, {
  old: 'Nimes',
  "new": '30 - Nimes'
}, {
  old: 'Orléans',
  "new": '45 - Orléans'
}, {
  old: 'Pau',
  "new": '64 - Pau'
}, {
  old: 'Poitiers',
  "new": '86 - Poitiers'
}, {
  old: 'Reims',
  "new": '51 - Reims'
}, {
  old: 'Saint Nazaire',
  "new": '44 - Saint-Nazaire'
}, {
  old: 'Toulon',
  "new": '83 - Toulon'
}, {
  old: 'Toulouse - Roques',
  "new": '31 - Toulouse Roques'
}, {
  old: 'Valenciennes',
  "new": '59 - Valenciennes'
}, {
  old: 'Saint-Brieuc',
  "new": '22 - Saint-Brieuc'
}, {
  old: 'Saint-Etienne',
  "new": '42 - Saint-Etienne'
}];